// (function(a,b,c){if(c in b&&b[c]){var d,e=a.location,f=/^(a|html)$/i;a.addEventListener("click",function(a){d=a.target;while(!f.test(d.nodeName))d=d.parentNode;"href"in d&&(d.href.indexOf("http")||~d.href.indexOf(e.host))&&(a.preventDefault(),e.href=d.href)},!1)}})(document,window.navigator,"standalone")

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.forgot-pw').forEach(function (element) {
    element.addEventListener('click', function (e) {
      e.preventDefault();
      var loginComponent = this.closest('.login-component');

      if (loginComponent) {
        loginComponent.querySelectorAll('.show__hide').forEach(function (el) {
          el.style.display = 'none';
        });
      }

      var target = this.getAttribute('href');
      if (target) {
        var targetElement = loginComponent.querySelector(target);
        if (targetElement) {
          targetElement.style.display = 'block';
        }
      }
    });
  });

  var link = document.querySelector('a[aria-controls="AddAddress"]');
  if (link) {
    link.addEventListener('click', function(event) {
      event.preventDefault(); 
      
      var addAddressDiv = document.getElementById('AddAddress');
      
      if (addAddressDiv.style.display === 'block') {
        addAddressDiv.style.display = 'none';
      } else {
        addAddressDiv.style.display = 'block';
      }
    });
  }

});
//popup batch msg and btns
  // Function to update the popup with cart data
    function updatePopupWithCartData(cartData) {
      const mainProductCount = cartData.items.reduce((total, item) => {
        return item.price >= 800 ? total + item.quantity : total;
      }, 0);


    var title = '';
    var message = '';
    var button = 'Noch 1 Artikel hinzufügen';

    switch (mainProductCount) {
      case 1:
        title = "Kostenloser Versand!";
        message = "Füge Sie 2 weitere Artikel hinzu und profitieren Sie vom kostenlosen Versand.";
        button = "Füge Sie 2 weitere Artikel hinzu.";
        break;
      case 3:
        title = "Kostenloser Versand!";
        message = "Füge Sie 2 weitere Artikel hinzu und erhalten Sie 10% Stapelrabatt.";
        button = "Füge Sie 2 weitere Artikel hinzu.";
        break;
      case 5:
        title = "10% freigeschaltet!";
        message = "Füge noch 2 Artikel hinzu und profitiere von 15% Stapelrabatt.";
        button = "Füge noch 2 Artikel hinzu";
        break;
      case 7:
        title = "15% freigeschaltet!";
        message="Füge noch 2 Artikel hinzu und profitiere von 20% Stapelrabatt.";
        button = "Füge noch 2 Artikel hinzu";
        break;
      case 9:
        title = "20% freigeschaltet!";
        message = "Füge noch 3 Artikel hinzu und profitiere von 25% Stapelrabatt.";
        button = "Füge noch 3 Artikel hinzu";
        break;
      case 12:
        title = "25% freigeschaltet!";
        message = "Herzlichen Glückwunsch, du hast den höchstmöglichen Stapelrabatt aktiviert.";
        button = "Füg noch mehr Artikel hinzu";
        break;
      default:
        break;
    }

    var popupElement = document.getElementById('popup-batch-discount');
    if (popupElement && message !== '') {
      popupElement.querySelector('.popup__batch--header').textContent = title;
      popupElement.querySelector('.popup__batch--subtitle').textContent = message;
      popupElement.querySelector('.popup__batch--button .btn').textContent = button;
      popupElement.classList.add('active');
    } else {
      popupElement.classList.remove('active');
    }
  }
//messages
  // Function to show messages
  function showMessage(type, iconClass, message) {
    var messageWrap = document.getElementById('messageWrap');
    var messageContent = document.getElementById('messageContent');
    var messageIcon = document.getElementById('messageIcon');
    var messageIconi = messageIcon.firstElementChild;
    var messageText = document.getElementById('messageText');

    messageContent.className = 'message ' + type;
    messageIcon.classList.add(type);
    messageIconi.className = 'fa ' + iconClass;
    messageText.textContent = message;

    messageWrap.classList.add('active');

    setTimeout(function () {
      messageWrap.classList.remove('active');
    }, 2000);
  }
// Slide cart functionality
function openCartDrawer() {
  document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
}

function closeCartDrawer() {
  document
    .querySelector(".cart-drawer")
    .classList.remove("cart-drawer--active");
}

// Update cart item count across the page
function updateCartItemCounts(count) {
  document.querySelectorAll(".items").forEach((el) => {
    el.textContent = count;
  });
}

// Ensure progress visibility after the first item is added
function toggleProgressVisibility(totalItems) {
  const progressContainer = document.querySelector('.discount-progress');
  progressContainer.style.display = totalItems > 0 ? 'block' : 'none';
}

// Function to fetch and update the cart drawer content
async function updateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;
  const newBox = html.querySelector(".cart-drawer").innerHTML;

  document.querySelector(".cart-drawer").innerHTML = newBox;
  updateProgressBar();
  addCartDrawerListeners();
}

// Attach event listeners to the cart drawer elements (e.g., buttons)
function addCartDrawerListeners() {
  // Update quantities
  document
    .querySelectorAll(".cart-drawer-quantity-selector button")
    .forEach((button) => {
      button.addEventListener("click", async () => {
        document.querySelector(".spinner").style.display = "flex";
        const rootItem = button.closest(".cart-drawer-item");
        const key = rootItem.getAttribute("data-line-item-key");
        const currentQuantity = Number(button.parentElement.querySelector("input").value);
        const isUp = button.classList.contains("cart-drawer-quantity-selector-plus");
        const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

        if (newQuantity < 0) return;

        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });

        const cart = await res.json();
        updateCartItemCounts(cart.item_count);
        await updateCartDrawer();
        document.querySelector(".spinner").style.display = 'none';
      });
    });

  // delete functionality
  document
    .querySelectorAll(".remove-btn")
    .forEach((button) => {
      button.addEventListener("click", async (event) => {
        event.preventDefault();
        const rootItem = button.closest(".cart-drawer-item");
        const key = rootItem.getAttribute("data-line-item-key");
        document.querySelector(".spinner").style.display = 'flex';
        // Remove the item by setting its quantity to 0
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: 0 } }),
        });

        const cart = await res.json();
        updateCartItemCounts(cart.item_count);
        await updateCartDrawer();
        document.querySelector(".spinner").style.display = 'none';
      });
    });

  // Prevent closing the cart drawer when clicking inside the drawer
  document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
    e.stopPropagation();
  });

  // Close the cart drawer on outside clicks
  document
    .querySelectorAll(".cart-drawer-header-right-close, .cart-drawer")
    .forEach((el) => {
      el.addEventListener("click", () => {
        closeCartDrawer();
      });
    });
}

// Update the cart after adding a product from the product page (now exist on main-product)
// document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
//   form.addEventListener("submit", async (e) => {
//     e.preventDefault();

//     // Submit form with ajax
//     await fetch("/cart/add", {
//       method: "post",
//       body: new FormData(form),
//     });

//     // Get cart count and update cart drawer
//     const res = await fetch("/cart.js");
//     const cart = await res.json();
//     updateCartItemCounts(cart.item_count);
//     await updateCartDrawer();
//   });
// });

// Open cart drawer on clicking the cart link
document.addEventListener("DOMContentLoaded", function() {
    const cartIcons = document.querySelectorAll('.cart-icon');
    cartIcons.forEach(cartIcon => {
      cartIcon.addEventListener('click', function(e) {
        e.preventDefault();
        openCartDrawer();
      })
    })
  
});



// Discount progress bar functionality
document.addEventListener('DOMContentLoaded', function () {
  const progressBar = document.getElementById('discountProgressBar');
  const progressMessage = document.getElementById('discountProgressMessage');

  // Immediately update the progress bar to the stored percentage
  const lastPercentage = localStorage.getItem('lastProgressPercentage') || '0';
  if (progressBar) {
    progressBar.style.width = lastPercentage + '%';
  }

  // Ensure the progress bar and message visibility based on the last stored percentage
  toggleProgressVisibility(lastPercentage);

  // Call updateProgressBar function to fetch the cart and update progress
  updateProgressBar();
});

// Function to update the progress bar and message
function updateProgressBar() {
  const progressBar = document.getElementById('discountProgressBar');
  const progressMessage = document.getElementById('discountProgressMessage');

  fetch('/cart.js')
    .then((response) => response.json())
    .then((cartData) => {
      const quantities = cartData.items.filter(item => { return item.price >= 800 && item.handle !== 'adventskalender'; }).map(item => item.quantity);
      const mainProductCount = quantities.reduce((total, quantity) => total + quantity, 0);

      // Calculate the percentage filled based on the product count (assuming 12 is the max count)
      const percentageFilled = Math.min((mainProductCount / 12) * 100, 100);

      // Update the progress bar width with animation
      progressBar.style.transition = 'width 1s ease';
      progressBar.style.width = `${percentageFilled}%`;

      // Update the message based on the product count
      const message = getMessage(mainProductCount);
      progressMessage.innerHTML = message;

      // Save the current progress percentage in localStorage
      localStorage.setItem('lastProgressPercentage', percentageFilled);

      // Update visibility of the progress bar and message
      toggleProgressVisibility(mainProductCount);
    })
    .catch((error) => console.error('Error updating progress bar:', error));
}

// Function to get the appropriate message based on product count
function getMessage(mainProductCount) {
  const messages = [
    '',
    'Fügen Sie 2 weitere Produkte hinzu und profitieren Sie vom kostenlosen Versand.',
    'Fügen Sie 1 Produkt hinzu und profitieren Sie von kostenlosem Versand.',
    'Kostenloser Versand! Fügen Sie 2 Produkte hinzu und profitieren Sie von 10% Stapelrabatt.',
    'Kostenloser Versand! Fügen Sie 1 Produkt hinzu und profitieren Sie von 10% Stapelrabatt.',
    '10% freigeschaltet! Fügen Sie 2 Produkte hinzu und profitieren Sie von 15% Stapelrabatt.',
    '10% freigeschaltet! Fügen Sie 1 Produkt hinzu und profitieren Sie von 15% Stapelrabatt.',
    '15% freigeschaltet! Fügen Sie 2 Produkte hinzu und profitieren Sie von 20% Stapelrabatt.',
    '15% freigeschaltet! Fügen Sie 1 Produkt hinzu und profitieren Sie von 20% Stapelrabatt.',
    '20% freigeschaltet! Fügen Sie 3 Produkte hinzu und profitieren Sie von 25% Stapelrabatt.',
    '20% freigeschaltet! Fügen Sie 2 Produkte hinzu und profitieren Sie von 25% Stapelrabatt.',
    '20% freigeschaltet! Fügen Sie 1 Produkt hinzu und profitieren Sie von 25% Stapelrabatt.',
    '25% freigeschaltet! Herzlichen Glückwunsch, Sie haben den höchstmöglichen Stapelrabatt aktiviert.'
  ];

  return messages[Math.min(mainProductCount, 12)];
}


// handle variant selection UI
document.addEventListener("DOMContentLoaded", function () {
  // Global array to store selected variants
  let selectedVariants = [];

  // Function to handle product variant selection
  function selectVariant(buttonElement) {
    const variantTitle = buttonElement.getAttribute('data-title');
    const variantPrice = buttonElement.getAttribute('data-price');
    const variantImage = buttonElement.getAttribute('data-image');
    const variantId = buttonElement.getAttribute('data-product-variant');
    
    const btnSolo = document.querySelector('#variant-solo');
    const productContainer = buttonElement.closest('.card-body'); // Find the product container
    const card = productContainer.closest('.card');
    const productId = productContainer.getAttribute('data-product-id'); // track variant

    // check if variant already exist
    const existingVariantIndex = selectedVariants.findIndex(
      (variant) => variant.productId === productId
    );
    // Store the selected variant details for this product container
    let selectedVariant = {
      title: variantTitle,
      price: variantPrice,
      imageUrl: variantImage,
      variantId: variantId,
      btnSolo: btnSolo,
      productId: productContainer.getAttribute('data-product-id') // Store the product ID to track variants
    };
    if (existingVariantIndex !== -1) {
      //replace existing variant
      selectedVariants[existingVariantIndex] = selectedVariant;
    } else {
      // Append the selected variant to the global array
      selectedVariants.push(selectedVariant);
    }
    console.log('Selected Variants:', selectedVariants);

    // Display the selected variant in the UI
    displaySelectedVariant(selectedVariant, productContainer);

    // remove red border and give green
    card.classList.add('valid-selection');
    // Close the modal (using Bootstrap's modal close method)
    const modalId = buttonElement.closest('.modal').id; // Get the modal ID dynamically
    $(`#${modalId}`).modal('hide');
  }

// Function to display the selected variant in the UI
function displaySelectedVariant(variant, productContainer) {
    // update image
    const productImage = productContainer.querySelector(`#productImg-${variant.productId}`); // Assuming productImg-{productId} is an ID
    if (productImage) {
        productImage.src = variant.imageUrl;
        productImage.alt = variant.title;
    }

    // update title
    const productTitle = productContainer.querySelector(`#title-${variant.productId}`); // Assuming title-{productId} is an ID
    if (productTitle) {
        productTitle.textContent = variant.title;
    }

    // update price
    const productPrice = productContainer.querySelector(`#price-${variant.productId}`); // Assuming price-{productId} is an ID
    if (productPrice) {
        productPrice.textContent = variant.price;
    }
    const btnSolo = productContainer.querySelector(`#variant-solo-${variant.productId}`);
    if (btnSolo) {
      btnSolo.style.display = 'block';
    }
}



  // Event delegation to handle clicks on dynamically generated buttons
  document.body.addEventListener('click', function (event) {
    if (event.target.classList.contains('select-variant')) {
      selectVariant(event.target); // Call the selectVariant function
    }
  });


// Function to add variant solo to cart
async function handleAddVariantToCart(buttonElement) {
  const productId = buttonElement.getAttribute('data-product-id'); // Get the product ID
  const selectedVariant = selectedVariants.find(variant => variant.productId === productId);


  const variantId = selectedVariant.variantId;

  try {
    // Send AJAX request to add the variant to the cart
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });

    if (response.ok) {
      const res = await fetch("/cart.js"); // Fetch updated cart
      const cart = await res.json();

      // Show success message
      const productTitle = selectedVariant.title || 'Product'; // Fallback in case title is missing
      showMessage('success', 'fa-check', `${productTitle} wird Ihrem Warenkorb hinzugefügt.`);

      // Update cart UI
      updatePopupWithCartData(cart);
      updateCartItemCounts(cart.item_count); // Update cart count
      updateCartDrawer(); // Update drawer UI if applicable
    } else {
      showMessage('info', 'fa-times', 'Product toegevoegd aan winkelwagen, maar titel niet gevonden.');
    }
  } catch (error) {
    console.error('Error adding to cart:', error);
    showMessage('error', 'fa-times', 'Er is een fout opgetreden bij het toevoegen aan de winkelwagen.');
  }
}


// Attach event listeners for "Add to Cart" buttons
document.querySelectorAll('.add-variant-to-cart').forEach(button => {
  button.addEventListener('click', function () {
      handleAddVariantToCart(this);
  });
});

  // Function to add a product variant to the cart
  async function addProductToCart(variantId, quantity = 1) {
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity,
        }),
      });

      if (!response.ok) throw new Error("Failed to add product to cart");
      console.log(`Variant ${variantId} added successfully.`);
    } catch (error) {
      console.error(`Error adding variant ${variantId}:`, error.message);
    }
  }
// add all look to cart
    const addAllToCartBtns = document.querySelectorAll(".add-all-to-cart");
  // Function to collect products with selected variants and add them to cart
async function addAllProductsToCart() {
  const productItems = document.querySelectorAll(".card-body.product-item-select");
  const productVariantIds = [];
  let allVariantsSelected = true; // Flag to check if all variants are selected

  document.querySelector(".spinner").style.display = "flex"; // Show spinner  
  productItems.forEach((item) => {
    let variantId = null;

    // Get the product ID to check for a selected variant
    const productId = item.closest(".card").getAttribute("data-product-id");

    // Check if the product has a selected variant in the global array
    const selectedVariant = selectedVariants.find(
      (variant) => variant.productId === productId
    );


    const card = item.closest('.card');

    // Remove the previous invalid-selection class to restart animation
    card.classList.remove('invalid-selection');

    if (selectedVariant) {
      // If the user has selected a variant, use its ID
      variantId = selectedVariant.variantId;
      card.classList.remove('invalid-selection'); // Ensure no red border if selected
    } else {
      // If the product has variants but none selected
      const variantButton = item.querySelector("button.select-variant");
      if (variantButton) {
        allVariantsSelected = false; // Mark that not all variants are selected
        card.classList.add('invalid-selection'); // Add red border with animation for missing variant
        card.classList.remove('valid-selection');
                // Scroll the card into view
        card.scrollIntoView({ behavior: 'smooth', block: 'center' });
      //trigger animation
      card.classList.add('animated');
      setTimeout(() => {
        card.classList.remove('animated');
      }, 500);
      }

      // If no variant is selected and it's a solo product, use the default variant ID
      const defaultVariant = item.querySelector("button.add-solo-to-cart");
      if (defaultVariant) {
        variantId = defaultVariant.getAttribute("data-product-variant");
      }
    }

    // Validate and collect the variant ID
    if (variantId) {
      productVariantIds.push(variantId);
    } else {
      console.warn(
        "Product skipped. No variant selected for product with ID:",
        productId
      );
    }
  });

  // Check if all variants are selected before adding to the cart
  if (!allVariantsSelected) {
    showMessage('info', 'fa-times', 'Zuerst alle Varianten auswählen');
    document.querySelector(".spinner").style.display = "none"; // Show spinner
    
    return; // Stop further processing if variants are not selected
  }

  // Add all valid variants to the cart
  if (productVariantIds.length > 0) {
    for (const variantId of productVariantIds) {
      await addProductToCart(variantId);
    }
    showMessage("success", "fa-check", "Alle Produkte wurden in Ihren Warenkorb gelegt.");
      document.querySelector(".spinner").style.display = "none"; // Show spinner
    // Get cart count and update cart drawer
    const res = await fetch("/cart.js");
    const cart = await res.json();
    updatePopupWithCartData(cart);
    updateCartItemCounts(cart.item_count); // This updates the cart count label
    await updateCartDrawer();
  } else {
    showMessage('info', 'fa-times', 'failed to process');
  }

}
  // Event listener for "Add All to Cart" buttons
addAllToCartBtns.forEach((btn) => {
  btn.addEventListener("click", function () {
    addAllProductsToCart();
  });
});

});
// Initialize listeners and elements on page load
addCartDrawerListeners();


// end cart slide
$(document).ready(function(){

  $('.language-section .option a').on('click', function() {
    $('.language-section .option').removeClass('active');
    $(this).closest('.option').addClass('active');

    var iso = $(this).attr('data-iso');
    $(this).closest('form').find('input[name="language_code"]').val(iso).trigger('change');

    $(this).closest('form').submit();
  });

  $('.cart-delete').click('click', function(){
  	$(this).closest('tr').find('[name="updates[]"]').val(0);
    $(this).closest('form').submit();
  });
  
// 	/* general */
//   $('[data-fancybox]').fancybox({
//   	touch: false,
//    	autoFocus: false,
//   });
  
//   // footer colors
//   var footerbg = $('#footer .main-footer').css('background-color');
//   if (lightOrDark(footerbg) == 'dark') {
//   	$('#footer .newsletter input').css('background', '#fff').css('color', '#aaa');
//     $('#footer .socials a').css('background', 'rgba(255,255,255,0.05)');
//   }
  
//   // open shipping calculator
//   if (getUrlParameter('shipping')) {
//     $('[href=#shipping-costs-popup]').trigger('click');
//     window.history.replaceState({}, document.title, "/" + "cart");
//   }
  
//   /* checkout */
//   if (customCartActive) {
//     checkoutStatus();
//     updatePayments();
//     setInterval(function() {
//       checkoutStatus();
//       updatePayments();
//     }, 500);
// 	}
  
//   // yotpo stars
//   loadYotpoStars();
  
  // Text fade toggle //
  $.fn.toggleHtml = function(t1, t2){
    if (this.html() == t1) this.html(t2);
    else                   this.html(t1);
    return this;
  };

  
  if ($(window).width() < 1199) {
    var content = $('[data-toggle-text]');
		var contentHeight = content.outerHeight();
    
    if (contentHeight > 250) {
    	content.addClass('faded');
    }
    
    $('.toggle-text').on('click', function(){
    	$(this).closest(content).find('.text').toggleClass('active');
      $(this).toggleHtml(readless+'<i class="fa fa-angle-up"></i>', readmore+'<i class="fa fa-angle-down"></i>');
    });
  }
  
//   /* productpage options */
//   $('.product-configure-custom-option-item input[type="radio"]').closest('.product-configure-custom-option-item').addClass('ui radio checkbox');
//   $('.product-configure-custom-option-item input[type="checkbox"]').closest('.product-configure-custom-option-item').addClass('ui checkbox');
  
//   /* service page */
//   $('.faq .faq-item .tab').on('click', function(){
//     $(this).closest('.faq-item').toggleClass('active').find('.page').slideToggle();
//   });
  
//   /* bundles */
//   $('.bundles-slider').owlCarousel({
//     loop:false,
//     margin: 0,
//     responsive: {
//     	0: {
//       	items: 1,
//       },
//       768: {
//       	items: 2,
//       },
//       992: {
//       	items: 2
//       },
//       1200: {
//       	items: 3
//       }
//     },
//     dots:true
//     // mouseDrag:false,
//     // touchDrag:false
//     //dots:true
//   })
//   $('.open-bundle-options').on('click', function(){
//   	$(this).next('.bundle-option').addClass('active');
//   });
//   $('.bundle-option-done').on('click', function(){
//   	$(this).closest('.bundle-option').removeClass('active');
//   });
  
//   /* newsletter popup */  
//   if ($('#newsletter-popup')) {
//     var showAfter = $('#newsletter-popup').data('show');
//     var showAfter = showAfter * 1000;
//     var hideFor = $('#newsletter-popup').data('hide');
//     var hideFor = hideFor / 24;
    
//     $('[data-fancybox="newsletter"]').fancybox({
//       afterClose: function(){
//         Cookies.set('closed', 'yes', { expires: hideFor });
//       }
//     });
    
//     if (Cookies.get('closed') != 'yes' && Cookies.get('registered') != 'yes') {
//       setTimeout(function(){
//         $('.open-newsletter').trigger('click');
//       }, showAfter);
//     }
    
//     $('.submit-newsletter').on('click', function(){
//     	var email = $(this).closest('form').find('input[name="email"]').val();
//       var input = $(this).closest('form').find('input[name="email"]');
//       var form = $(this).closest('form');
//       if( !isValidEmailAddress(email) ) {
//         input.addClass('error');
//       } else {
//         Cookies.set('registered', 'yes', { expires: 365 });
//         form.submit();  
//       }
//     });
    
//     //Cookies.set('registered', 'yes', { expires: 365 });
    
// 	}
//   /* end newsletter popup */
  
	// HEADLNES //
  var headlinesAutoplay = $('.headlines').data('autoplay');
  var loopSetting = $('.headlines').data('loop');
  if(loopSetting){
  	loopSetting = setLoop($('.headlines').data('items'), 1);
  }
  var pagination = $('.headlines').data('pagination');
  //console.log(pagination);
  $('.headlines').owlCarousel({
    loop: loopSetting,
    margin:0,
    nav:false,
    items:1,
    dots:pagination,
	  autoplay:headlinesAutoplay,
    autoplayTimeout:3000,
    touchDrag: loopSetting,
    mouseDrag: loopSetting
  });
  
  // var video = $('.headlines').data('video');
  // if (template == 'pages/index.rain' && video) {
  // 	$('.headlines .vid video')[0].play();
	// }
  // END HEADLINES //
  
//   /* live compare */
//   $('.open-compare').on('click', function(){
//   	$(this).closest('.compare-pop').toggleClass('open');
//     $('.compare-overlay').toggleClass('active');
//   });
//   $('.compare-overlay').on('click', function(){
//   	$('.compare-pop').removeClass('open');
//     $('.compare-overlay').removeClass('active');
//   });
  
//   $('.compare-check').live('change', function(){
//   	var cur = $(this);
//     if ($(this).is(':checked')) {
//     	var url = cur.data('add-url');
//     } else {
//     	var url = cur.data('del-url');
//     }
    
//     $.ajax({
//       type: "POST",
//       url: url,
//     });
    
//     setTimeout(function(){
//     	compare();
//     }, 500);
    
//   });
  
//   $('.delete-compare').live('click', function(){
//   	var url = $(this).attr('data-del-url');
    
//     $(this).closest('.compare-product').remove();
//     $.ajax({
//       type: "POST",
//       url: url,
//     });
    
//     setTimeout(function(){
//     	compare();
//     }, 500);
    
//   });
  
//   /* blog */
//   $('.regular-articles .blog-articles').masonry();
  
//   /* productpage reviews */
//   $('.normal-reviews .reviews-slider').owlCarousel({
//     loop:false,
//     items:1,
//     smartSpeed: 0,
//     autoHeight:true,
//     mouseDrag:false,
//     touchDrag:false
//     //dots:true
//   }).on('changed.owl.carousel', function(){
//     setTimeout(function(){
//       var activePage = $('.reviews-slider .owl-item.active').find('.page').data('index');
//       $('.product-reviews .custom-pager .number.active').removeClass('active');
//       $('.product-reviews .custom-pager .number[data-index="'+activePage+'"]').addClass('active');
//     }, 50);
//   });
  
//   $('.product-reviews .custom-pager [data-way]').live('click', function(){
//   	var way = $(this).data('way');
//     $('.reviews-slider').trigger(way+'.owl.carousel');
// 	});
  
//   $('.product-reviews .custom-pager .number a').live('click', function(){
//   	var pageIndex = $(this).data('index');
//     $('.reviews-slider').trigger('to.owl.carousel', (pageIndex-1));
// 	});
  
  /* productpage images */
  $('.product-images').owlCarousel({
    loop:false,
    margin:0,
    //nav:true,
    items:1,
    responsive:{
      0: {
        mouseDrag: true,
        touchDrag: true,
        dots: true,
      },
      768: {
        mouseDrag: false,
        touchDrag: false,
        dots: false,
      },
    }
    //navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>']
  }).on('translated.owl.carousel', function(){
  	//console.log('test');
  });
  $('.product-thumbs').owlCarousel({
    loop:false,
    margin:10,
    //nav:true,
    items:5,
    //navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>']
  });
  $('.product-thumbs .image').on('click', function(){
    
  	var imgIndex = $(this).data('index');
    $(this).closest('.product-thumbs').find('.image.active').removeClass('active');
    $(this).addClass('active');
    $(this).closest('.images').find('.product-images').trigger('to.owl.carousel', (imgIndex-1));
    var lastActive = $('.product-thumbs .owl-item.active').last().find('.image');
    if (lastActive.hasClass('active')) {
    	$('.product-thumbs').trigger('next.owl.carousel');	
    }
   var firstActive = $('.product-thumbs .owl-item.active').first().find('.image');
    if (firstActive.hasClass('active')) {
    	$('.product-thumbs').trigger('prev.owl.carousel');	
    }
  });
  
//   /* mobile filters apply */
  $('.apply-filters').on('click', function(e){
  	e.preventDefault();
    $(this).closest('form').submit();
  });
  
//   // SUBMIT CUSTOM FORMS //
//   $('.submit-form').on('click', function(e){
//     e.preventDefault();
    
//     var form = $(this).closest('form');
//     var error = false;
    
//     var requiredFields = form.find('.required');
//     $.each(requiredFields, function(key, field){
      
//       if($(this).val() == "" || $(this).val() == " "){
//         $(this).addClass('error');
//         error = true;
//       }
//     });
    
//     if(error == true){
//       return false;
//     }
    
//     form.submit();
//     return false;
//   });
//   // END SUBMIT CUSTOM FORMS //
  
//   // SUBMIT CUSTOM FORMS live //
//   $('.submit-live').on('click', function(e){
//     e.preventDefault();
    
//     var form = $(this).closest('form');
//     var url = form.attr('action');
//     var error = false;
    
//     var requiredFields = form.find('.required');
//     $.each(requiredFields, function(key, field){
      
//       if($(this).val() == "" || $(this).val() == " "){
//         $(this).addClass('error');
//         error = true;
//       } else {
//       	$(this).removeClass('error');
//       }
//     });
    
//     if(error == true){
//       return false;
//     }
    
//     $.ajax({
//       type: "POST",
//       url: url,
//       data: form.serialize(),
//       success: function(){
//         $('.live-message .message .icon i').removeClass('fa-info fa-check fa-times');
//         $('.live-message').addClass('active');
//         $('.live-message .message .icon').removeClass('error success info').addClass('success');
//         $('.live-message .message .text ul li').html(ajaxTranslations['Your review has been accepted for moderation.']);
//         $('.live-message .message .icon i').addClass('fa-check');

//         setTimeout(function(){
//           $('.live-message').removeClass('active');
//         }, 4000);	
        
//         parent.$.fancybox.close();
        
//       }
//     });
    
//     return false;
//   });
//   // END SUBMIT CUSTOM FORMS //
  
  // HOME COLLECTIONS //
  var collectionCount = $('.categories-slider .category').length;

  var responsiveBreakpoints = {
    0: 2.3,
    768: 2,
    992: 5
  };

  function shouldLoop() {
    var windowWidth = $(window).width();
    var maxItems = 1;
  
    for (var breakpoint in responsiveBreakpoints) {
      var breakpointNum = parseInt(breakpoint, 10); // Convert string to number
      if (windowWidth >= breakpointNum) {
        maxItems = responsiveBreakpoints[breakpoint];
      }
    }
  
    return collectionCount > maxItems;
  }

  $('.categories-slider').owlCarousel({
    loop: shouldLoop(),
    margin: 0,
    autoplay: false,
    responsive: {
      0: {
        items: responsiveBreakpoints[0]
      },
      768: {
        items: responsiveBreakpoints[768]
      },
      992: {
        items: responsiveBreakpoints[992]
      }
    }
  });

  // $(window).resize(function() {
  //   $('.categories-slider').trigger('destroy.owl.carousel').owlCarousel({
  //     loop: shouldLoop(),
  //     margin: 0,
  //     autoplay: false,
  //     responsive: {
  //       0: {
  //         items: responsiveBreakpoints[0]
  //       },
  //       768: {
  //         items: responsiveBreakpoints[768]
  //       },
  //       992: {
  //         items: responsiveBreakpoints[992]
  //       }
  //     }
  //   });
  // });

  
//    // HOME CATEGORIES //
//   $('.article-slider').owlCarousel({
//     loop:true,
//     margin:0,
//     autoplay:true,
//     autoplayTimeout:4000,	
//     responsive:{
//         0:{
//             items:2
//         },
//         768:{
//             items:3
//         },
//         992:{
//             items:4
//         }
//     }
// 	});
  
  // MORE IMAGES THUMB CLICK
  $('.products .product .more-images .image').on('click', function(){
  	var product = $(this).closest('.product');
    var image = $(this).data('url');
    $(this).closest('.images').find('.image.active').removeClass('active');
    $(this).addClass('active');
    product.find('.img-wrap img').attr('src', image);
  });
  
  
  // HOME PRODUCTS //
  function toggleProductsSlider() {
    var isMobile = $(window).width() < 768; // Adjust the width as needed for your mobile breakpoint
  
    if (isMobile) {
      // Destroy Owl Carousel if it's initialized
      if ($('.home-products .products-slider').hasClass('owl-loaded')) {
        $('.home-products .products-slider').trigger('destroy.owl.carousel');
      }
      $('.home-products .products-slider').addClass('show__products');
      // Apply mobile specific styles or classes if needed
    } else {
      // Initialize Owl Carousel if it's not already initialized
      $('.home-products .products-slider').removeClass('show__products');

      if (!$('.home-products .products-slider').hasClass('owl-loaded')) {
        var tiles = $('.home-products .products-slider').data('tiles');
        if (tiles) {
          var tiles = tiles.split('|');
          $('.home-products .products-slider').owlCarousel({
            //loop:true,
            autoplayHoverPause: true,
            margin:0,
            nav:false,
            //navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            items:1,
            autoplay:true,
            autoplayTimeout:3500,
            responsive:{
                0:{
                    items:tiles[3]
                },
                768:{
                    items:tiles[2]
                },
                992:{
                    items:tiles[1]
                },
                1200: {
                    items:tiles[0]
                }
            }
          });
          var productsSlider = $('.products-slider');
          var sliderIndex = 0;
          $.each(productsSlider, function(){
            var cur = $(this);
            sliderIndex++;
            if (sliderIndex != 1) {
              cur.closest('.page').removeClass('active');
            }
          });
        }
      }
    }  
  }
  
  toggleProductsSlider();
  $(window).resize(toggleProductsSlider);
    
  
  
  // cart page products
  var tiles = $('#cart-page .products-slider').data('tiles');
  if (tiles) {
    var tiles = tiles.split('|');

    $('#cart-page .products-slider').owlCarousel({
      //loop:true,
      autoplayHoverPause: true,
      margin:0,
      nav:false,
      //navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
      items:1,
      autoplay:true,
      autoplayTimeout:3500,
      responsive:{
          0:{
              items:tiles[3]
          },
          768:{
              items:tiles[2]
          },
          992:{
              items:tiles[1]
          },
          1200: {
              items:tiles[0],
          }
      }
    });
  }
  
//   // HOME Brands //
  $('.home-brands .brands-slider').owlCarousel({
  	loop: true,
    nav: false,
    autoplay: true,
    responsive: {
    	0: {
      	items: 2,
      },
      425: {
      	items: 3,
      },
      768: {
      	items: 4,
      },
    	992: {
      	items: 5,
      },
      1200: {
      	items: 6,
      },
    }
  });
  
   // TABS //
  $('.tabs-wrap .tabs li a').on('click', function(){
    var index = $(this).data('index');
    $('.tabs-wrap .tabs li.active').removeClass('active');
    $(this).closest('li').addClass('active');
    $('.tabs-wrap .pages .page.active').removeClass('active');
    $('.tabs-wrap .pages .page.page-'+index).addClass('active');
  });

  // scroll to element
 	$('[data-scroll]').on('click', function(){
    var element = $(this).data('scroll');
    var headerHeight = 0;
    if (typeof stickyHeader !== 'undefined' && stickyHeader) {
      headerHeight = $('#header .main-header').outerHeight();
    }
    $('html, body').animate({
      	scrollTop: $(element).offset().top - headerHeight - 30
    }, 500);
  });

 	// MOBILE MENU //
  $(document).on('click', '.open-subs', function(e){
      e.preventDefault();
      var moreCats = $(this).find('.more-cats');
      if (moreCats.length > 0) {
          moreCats.trigger('click');
      }
  });

  $('.mobile-menu .menu ul li .more-cats').on('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      var cur = $(this);
      cur.toggleClass('fa-rotate-90');
      cur.closest('li').find('.subs').first().toggleClass('active');
  });

  
  $('.mobile-menu .subs-back').on('click', function(){
  	$(this).closest('.subs').removeClass('active');
    subsHeight();
  });
  
  /* MOBILE BAR */
  $('.open-mobile-slide').on('click', function(){
    var cur = $(this);
  	var popup = $(this).data('popup');
    if (!cur.hasClass('active')) {
    	$('.mobile-popup.open').removeClass('open');
  	}
    $('.mobile-popup[data-popup="'+popup+'"]').toggleClass('open');
    $('.open-mobile-slide.active').removeClass('active');
    var openPopup = $('.mobile-popup.open').data('popup');
    $('.open-mobile-slide[data-popup="'+openPopup+'"][data-main-link]').addClass('active');
  });
  
  $('.open-mobile-slide[data-popup="search"]:not(.active)').click('click', function(){
    setTimeout(function(){
  		$('[data-popup="search"] input').focus();
    }, 200);
  });
  
  $('.close-popup').on('click', function(){
    var popup = $(this).closest('.mobile-popup').data('popup');
  	$(this).closest('.mobile-popup').removeClass('open');
    $('.open-mobile-slide[data-popup="'+popup+'"]').removeClass('active');
    setTimeout(function(){
    	$('.mobile-menu .subs').removeClass('active');
    }, 200);
  });
  
//   /* usp */
//   $('.usp-slider').owlCarousel({
//     loop:true,
//     margin:0,
//     items:1,
//     autoplay:true
// 	});

  // OPEN FILTERS
  $('.open-filters').on('click', function(){
  	$('.filters-top').slideToggle(200);
  });
  
  // NICE LOOKING SELECTS
  $('.custom-select, #productpage .product-option select, .bundle-option select').dropdown();
  
//   // MESSAGES
//   setTimeout(function(){
//     $('.message-wrap:not(.live-message)').removeClass('active');
//   }, 4000);
  
  
//   /* livesearch*/
//   $('.search-form input').keyup(function(){
//     liveSearch($(this));
//   });
//   $('.search-form input').bind('webkitspeechchange', function(){
//     liveSearch($(this));
//   });
//   $('.search-autocomplete input[type="checkbox"], .search-autocomplete input[type="radio"], .search-autocomplete select').live('change', function(){
//   	liveSearch($(this));
//   });

  // FOOTER TABS
function initMobSlideAccordion(scope) {
  if ($(window).width() < 992) {
    const $scope = $(scope);

    // Check what type of accordion this is
    const isFooter = $scope.find('.footer-title').length > 0;
    const triggerClass = isFooter ? '.footer-title' : '.title';
    const contentClass = isFooter ? '.content-wrap' : '.content-des';

    $scope.find(triggerClass).off('click').on('click', function () {
      const $this = $(this);

      const $allTitles = $scope.find(triggerClass);
      const $allContents = $scope.find(contentClass);

      if (!$this.hasClass('active')) {
        // Close all
        $allTitles.removeClass('active');
        $allContents.removeClass('active').slideUp(300);

        // Open clicked
        $this.addClass('active');
        $this.next(contentClass).addClass('active').slideDown(300);


      } else {
        // Toggle current
        $this.removeClass('active');
        $this.next(contentClass).removeClass('active').slideUp(300);
      }
    });
  }
}


  //call collapse in footer
  initMobSlideAccordion('#footer');
  //call collapse in product page
  initMobSlideAccordion('#product-collapse');
  //call collapse in box contents
  initMobSlideAccordion('#product-collapse-box');

  
  // SIDEBAR CATS
  $('.menu-box ul li .more-cats, .sidebar ul.side-cats li .more-cats, .sidebar ul.sb-cats-wrap li .more-cats').on('click', function(){
    var cur = $(this);
    if (!(cur.closest('li').hasClass('active'))) {
      cur.closest('ul').find('li').removeClass('active');
      cur.closest('ul').find('li ul').slideUp(300);
      cur.closest('li').addClass('active');
      cur.closest('li').find('>ul').slideDown(300);
    } else {
      cur.closest('li').removeClass('active');
      cur.closest('li').find('>ul').slideUp(300);
    }
    
    $(this).closest('li').find('.mobile-tab').slideToggle();
  });
  
  /* header */
  $('.open-vertical-menu').on('click', function(){
  	$('.vertical-menu-overlay, #header .vertical-menu, .vertical-menu-wrap').toggleClass('active');
  });
  $('.vertical-menu-overlay').on('mouseenter', function(){
  	$('.vertical-menu-overlay, #header .vertical-menu, .vertical-menu-wrap').removeClass('active');
  });
  
  /* input change */
  $('.input-wrap .change a').on('click', function(){
  	var cur = $(this);
    var way = $(this).attr('data-way');
    updateQuantity(way, cur);
  });

  
//   // ADD TO WISHLIST
//   $('.add-to-wishlist').on('click', function(){
//     if (loggedIn) {
//       var url = $(this).data('url');
//       $(this).addClass('in-wishlist');
//       $.ajax({
//         type: "POST",
//         url: url,
//         //data: form.serialize()
//       });
//       setTimeout(function(){
//         refreshWishlist();
//       }, 500);
//     }
//   });
//   if (shopSsl) {
//   	refreshWishlist();
//   }
  
//   // CART POPUP CHANGE
//   $('a[href="#cart-popup"], a[data-popup="cart"]').on('click', function(){
//   	updateCart();
//   });
//   $('.cart-wrap form').keypress(function (e) {
//     var form = $(this);
//      if (e.which == 13) {
//        form.submit();
//     //  $.ajax({
//     //   type: "POST",
//     //   data: form.serialize(),
//     //   url: form.attr('action'),
//     // }).done(function(data){
//     // 	createMessage(data);
//     //   updateCart();
//     // });
//       return false;    //<---- Add this line
//     }
//   });
//   $('.add-discount').on('click', function(){
//     var form = $(this).closest('form');
//     var url = form.attr('action');
    
//     form.submit();
//     // $.ajax({
//     //   type: "POST",
//     //   data: form.serialize(),
//     //   url: url,
//     // }).done(function(data){
//     // 	createMessage(data);
//     //   updateCart();
//     // });
    
//   });
  
//   $('.cart-wrap .table .input-wrap .change a').live('click', function(e){
//    	e.preventDefault();
//   	var form = $(this).closest('form');
//     var url = form.attr('action');
//     var btn = $(this);
//    	var btnText = $(this).html();
//     var type = 'add';
    
//     form.submit();
// //     $.ajax({
// //       type: "POST",
// //       data: form.serialize(),
// //       url: url,
// //     }).done(function(data){
// //     	createMessage(data);
      
// //       updateCart(btn, btnText, type);
      
// //     });
    
//   });
  
//   // CART POPUP/PAGE
//   $('#gui-form-shipping input[type="radio"]').live('change', function(){
//   	$(this).closest('form').submit();
//   });
//   $('.submit-shipping, .shipping-costs-block select[name="country"]').on('click change', function(){
//   	var cartUrl = basicUrl+'cart?format=json';
//     var form = $(this).closest('form');
//     var url = form.attr('action');
//     var cur = $(this);
//     $.ajax({
//       type: "POST",
//       data: form.serialize(),
//       url: url,
//     }).done(function(data){
//       $.get(cartUrl, function(data){
//       	var cart = data.cart;
//         if (cart.shipping.methods) {
//           cur.closest('.shipping-costs-block').find('.radio-block').empty();
//           $.each(cart.shipping.methods, function(index, method){
//             var html = '';
//           	html+='<div class="radio-wrap ui checkbox radio">';
//               html+='<input id="gui-form-shipping-'+method.id+'" type="radio" name="method" value="'+method.id+'" '+((method.id == cart.shipment.id) ? checked="checked" : '')+' />';
//               html+='<label for="gui-form-shipping-'+method.id+'">'+method.title+' <span>('+money(method.price_incl)+')</span></label>';
//             html+='</div>';
//             cur.closest('.shipping-costs-block').find('.radio-block').append(html);
//           });
//           cur.closest('.shipping-costs-block').find('.no-shipments').addClass('hidden');
//           cur.closest('.shipping-costs-block').find('.methods-block').removeClass('hidden');
//         } else {
//         	cur.closest('.shipping-costs-block').find('.no-shipments').removeClass('hidden');
//           cur.closest('.shipping-costs-block').find('.methods-block').addClass('hidden');
//         }
//       });
//     });

//   });
  
//   // QUICKVIEW OPEN
//   $('.quickview-button .show-btn').live('click', function(){
//     var cur = $(this);
//     var id = cur.parent().find('.open-link').attr('href');
//     var url = $(this).attr('data-product-url').replace('.html', '.ajax');
//     cur.parent().find('.open-link').trigger('click');
//     if (!$(id).hasClass('quickview-loaded')) {
//     $.get(url, function(product){
//       var variants = product.variants;
//       var images = product.images;
//       if (variants.length != 0) {
//         $(id).find('.product-option').removeClass('hidden');
//         $.each(variants, function(index, variant){
//           if (variant.stock.available) {
//             var available = 'true';
//           } else {
//             var available = 'false';
//           } 
          
//           if (product.vid == variant.id) {
//           	$(id).find('.variants').append('<option data-url="'+basicUrl+'cart/add/'+variant.id+'/" selected="selected" data-price="'+money(variant.price.price)+'" data-price-old="'+ ((variant.price.price_old) ? money(variant.price.price_old) : '')+'" data-available="'+available+'" data-stock-level="'+variant.stock.level+'" data-stock-track="'+variant.stock.track+'">'+ variant.title.replace(/"/g, "") +' - '+money(variant.price.price)+'</option>');
//         	} else {
//           	$(id).find('.variants').append('<option data-url="'+basicUrl+'cart/add/'+variant.id+'/" data-price="'+money(variant.price.price)+'" data-price-old="'+ ((variant.price.price_old) ? money(variant.price.price_old) : '')+'" data-available="'+available+'" data-stock-level="'+variant.stock.level+'" data-stock-track="'+variant.stock.track+'">'+ variant.title.replace(/"/g, "") +' - '+money(variant.price.price)+'</option>');
//           }
//         });
//       }
      
//       if (images.length != 0) {
//         var imgIndex = 0;
//         $(id).find('.quickview-images').empty();
        
//         $(id).find('.quickview-thumbs').empty();
//         $.each(images, function(index, image){
//           imgIndex++;
//         	var image = image.replace('50x50x2', '500x500x2');
//           if (theme.product_image_background_gray) {
//           	var imageType = 'img-gray';    
//           } else {
//           	var imageType = '';  
//           }
//           if (imgIndex == 1) {
//           	var activeClass = 'active';    
//         	} else {
//           	var activeClass = '';    
//           }
//           $(id).find('.quickview-images').append('<div class="item"><div class="image '+imageType+'"><img src="'+image+'"></div></div>');
//           $(id).find('.quickview-thumbs').append('<div class="item"><div class="image '+imageType+' '+activeClass+'" data-index="'+imgIndex+'"><img src="'+image+'"></div></div>');
//         });
//       }

//       var stockDiv = $(id).find('.product-info').find('.stock');
//       if ((product.stock.available && product.stock.level != 0) || !product.stock.track) {
//         if (showStockLevel) {
//           stockDiv.html('<div class="green success-color"><i class="fa fa-check"></i>'+product.stock.level+' '+inStock_t_lower+'</div>');
//         } else {
//           stockDiv.html('<div class="green success-color"><i class="fa fa-check"></i>'+inStock_t_lower+'</div>');
//         }
//       } else if (product.stock.available && product.stock.level == 0) {
//         stockDiv.html('<div class="orange warning-color"><i class="fa fa-check"></i>'+outOfStock_t_lower+'</div>');
//       } else {
//         stockDiv.html('<div class="red error-color"><i class="fa fa-times"></i>'+outOfStock_t_lower+'</div>');
//       }
      
//     }).done(function(){
//       $(id).find('select').dropdown();
//       $(id).addClass('quickview-loaded');
//       $(id).find('.quickview-images').owlCarousel({
//         loop:false,
//         margin:0,
//         //nav:true,
//         items:1,
//         mouseDrag:false,
//         touchDrag:false
//         //navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>']
//     	});
//       $(id).find('.quickview-thumbs').owlCarousel({
//         loop:false,
//         margin:10,
//         //nav:true,
//         items:4,
//         //navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>']
//     	});
//       if (!$(id).find('.product-option').hasClass('hidden')) {
//       	getActiveQuickviewVar($(id).find('select'));
//     	}
//     });
//     }
//   });
//   $('.open-link[data-fancybox]').fancybox({
//   	 autoFocus : false,
//   });
//   $('.quickview-popup select').live('change', function(){
//   	var cur = $(this);
//     getActiveQuickviewVar(cur);
//   });
//   $('.quickview-popup .quickview-thumbs .image').live('click', function(){
//     var cur = $(this);
//   	var imgIndex = $(this).data('index');
//     $(this).closest('.quickview-thumbs').find('.image.active').removeClass('active');
//     $(this).addClass('active');
//     $(this).closest('.images').find('.quickview-images').trigger('to.owl.carousel', (imgIndex-1));
//     var lastActive =  $(this).closest('.quickview-thumbs').find('.owl-item.active').last().find('.image');
//     if (lastActive.hasClass('active')) {
//     	 cur.closest('.quickview-thumbs').trigger('next.owl.carousel');	
//     }
//    var firstActive =  $(this).closest('.quickview-thumbs').find('.owl-item.active').first().find('.image');
//     if (firstActive.hasClass('active')) {
//     	 cur.closest('.quickview-thumbs').trigger('prev.owl.carousel');	
//     }
//   });
  
//   // ORDER TIMER //
//   var dt = new Date();
//   var time = dt.getHours();
//   var year = dt.getFullYear();
//   var month = dt.getMonth()+1;
//   var day = dt.getDate();
//   var dayNr = dt.getDay();
//   var currentDate = dt.getFullYear() + '/' +
//       (month<10 ? '0' : '') + month + '/' +
//       (day<10 ? '0' : '') + day;

//   var currentDateDutch =  (day<10 ? '0' : '') + day + '-'+ (month<10 ? '0' : '') + month + '-' + dt.getFullYear()
//   var showClock = true;

  
//   $.each(showDays, function(index, showDay){
//     showDay = showDay.trim();
//     showDay = parseInt(showDay);
//     showCountdownTill = parseInt(showCountdownTill);
//    	showCountdownFrom = parseInt(showCountdownFrom);
//     if(dayNr == showDay && time >= showCountdownFrom) {
//       $('.order-countdown .countdown .time').countdown(currentDate +' '+showCountdownTill+':00')
//         .on('update.countdown', function(event) {
//           var format = '%-H:%M:%S';
//           $(this).html(event.strftime(format));
//         	$('.order-countdown .countdown').removeClass('hidden');
//       }).on('finish.countdown', function(event) {
//         $('.order-countdown .countdown').addClass('hidden');
//       });
//     }
//   });
//   // END ORDER TIMER //
  
//   // banners TIMER //
//   var bannerDate = $('.banner-timer').data('date');
//   var timeKind = {0: 'days', 1: 'hours', 2: 'minutes', 3: 'seconds'};
//   $('.banner-timer').countdown(bannerDate +' 00:00:00').on('update.countdown', function(event) {
//         //var format = '::%M';
//     		var date = event.strftime('%D:%H:%M:%S');
//     		var blocks = date.split(':');
//     		var html = '';
//     		$.each(blocks, function(index, block){
//           var digits = block.split('');
//           html += '<div class="block '+timeKind[index]+'">';
//           $.each(digits, function(index, digit){
//           	 html += '<span class="digit">'+digit+'</span>';
//           });
//           html += '<div class="time-title">'+timeKind[index]+'</div>';
//           html += '</div>';
//         });
//     		$('.banner-timer').html(html);
//         $('.banner-timer').removeClass('hidden');
//     }).on('finish.countdown', function(event) {
//       $('.banner-timer').addClass('hidden');
//     });
  
//   // END ORDER TIMER //
  
//   // account dashboard
  
//   $('.return-dropdown select').on('change', function(){
//   	var selected = $(this).find('option:selected').val();
//     console.log(selected);
//     var cur = $(this);
//     if (selected == 'specify') {
//       cur.closest('.input').next('.specify').removeClass('hidden');
//     } else {
//     	cur.closest('.input').next('.specify').addClass('hidden');
//     }
//   });
  
//   $('.chat-box-outer').scroll();
//   var height = $('.chat-box-outer').innerHeight();
//   $('.chat-box-outer').animate({
//     scrollTop: 50000
//   }, 0);
  
//   setInterval(function(){
//   	refreshChats();
//   }, 5000);
  
//   $('#ticketForm').on('submit', function(e){
//   	e.preventDefault();
//     var url = $(this).attr('action');
//     var form = $(this);
    
    
//     $.ajax({
//       type: "POST",
//       url: url,
//       data: form.serialize(),
//     }).done(function(){
//     	refreshChats();
//       form.find('input[type="text"]').val('');
//     });
    
    
//   });
  
//   $('select[name="type"]').on('change', function(){
//   	var type = $(this).find('option:selected').val();
//     if (type == 'company') {
//      	$('#account-dashboard').find('.company-info').removeClass('hidden');   	
//     } else {
//     	$('#account-dashboard').find('.company-info').addClass('hidden');   	
//     }
//   });
//   $('#account-dashboard [name="password_change"]').on('change', function(){
//   	var checked = $(this).prop('checked');
//     if (checked) {
//      	$('#account-dashboard').find('.change-password').removeClass('hidden');   	
//     } else {
//     	$('#account-dashboard').find('.change-password').addClass('hidden');   	
//     }
//   });
  
//   if (accountCountries) {
//   var country_id = $('#account-dashboard select[name="country"]').find('option:selected').val();
//   account_regions(country_id);
//   $('#account-dashboard select[name="country"]').on('change', function(){
//   	var country_id = $(this).find('option:selected').val();
//     account_regions(country_id);
//   });
// 	}
//   if ($('.recent-orders.dash').length > 0) {
//   	var ordersUrl = createUrl('account/orders')+ '?format=json';
//     ordersUrl = ordersUrl.replace('http:', 'https:');
//     $.get(ordersUrl, function(data){
//     	if (data.orders.items) {
//       	$('.recent-orders').empty();
//         var orderIndex = 0;
//         $.each(data.orders.items, function(index, order){
//           orderIndex++;
//           var status = '';
//           if (order.status == ajaxTranslations['Awaiting payment'] || order.status == ajaxTranslations['Awaiting pickup'] || order.status == ajaxTranslations['Awaiting shipment']) {
//           	status = 'warning';
//           } else if (order.status == ajaxTranslations['Cancelled']) {
//             status = 'error'; 
//           } else if (order.status == ajaxTranslations['Picked up'] || order.status == ajaxTranslations['Shipped']) {
//           	status = 'success'; 
//           }
          
//         	html = '';
//           html += '<div class="recent-order">';
//             html += '<div class="inner">';
//               html += '<div class="col">';
//                 html += '<div class="order-label">'+ajaxTranslations['Order']+'</div>';
//                 html += '<div class="title title-font">'+ order.number +'</div>';
//               html += '</div>';
//               html += '<div class="col hidden-xs">';
//                 html += '<div class="order-label">'+ajaxTranslations['Date']+'</div>';
//                 html += '<div class="title title-font">'+moment(order.date).format('DD-MM-Y')+'</div>';
//               html += '</div>';
//               html += '<div class="col">';
//                 html += '<div class="order-label">'+ajaxTranslations['Total']+'</div>';
//                 html += '<div class="title title-font">'+ money(order.price) +'</div>';
//               html += '</div>';
//               html += '<div class="col hidden-xs">';
//                 html += '<div class="order-label">'+ajaxTranslations['Status']+'</div>';
//                 html += '<div class="status-label '+status+'">'+ order.status +'</div>';
//               html += '</div>';
//               html += '<div class="col">';
//                 html += '<a class="btn accent" href="'+ createUrl('account/ordersView/'+order.id) +'"><i class="fa fa-angle-right"></i></a>';
//               html += '</div>';
//             html += '</div>';
//           html += '</div>';
//           if (orderIndex < 3) {
//           	$('.recent-orders').append(html);
//           }
//         });
        
//         $('[data-order-q]').html('('+orderIndex+')');
        
//       } else {
//       	$('<div class="">'+ajaxTranslations['No orders found']+'...</div>').insertBefore('.recent-orders');
//       }
//     });
//   }
  
});

// $(window).load(function(){
//   sizing();
// });
// $(window).resize(function(){
//   sizing();
// });
// $(document).ready(function(){
// 	sizing();
// });

// function sizing() {
  
//   if ($(window).width() > 767) {
//     if (addedToCart) {
//       $('.open-addcart-popup').trigger('click');
//     }
//   }
  
//   if ($(window).width() > 991) {
//   	$('.product-detail .top-info').each(function(){
//     	$(this).prependTo($(this).closest('.product-detail').find('.product-info'));
//     });
//   } else {
//   	$('.product-detail .top-info').each(function(){
//     	$(this).prependTo($(this).closest('.product-detail'));
//     });
//   }
  
//   /* sticky header */
// 	if ($('.topbar').length > 0) {
//     var scrollheight = $('.topbar').outerHeight();
//   } else {
//     var scrollheight = 0;
//   }
//   var stickyDiv = $('#header .main-header');
//   var stickyHeight = $('#header .main-header').outerHeight();
//   var mainHeaderHeight = $('#header .main-header').outerHeight();
  
//   if (stickyHeader && $(window).width() > 767) {
//     $(window).scroll(function() {
//       if ($(this).scrollTop() > scrollheight) { // this refers to window
//         stickyDiv.addClass('sticky');
//         var stickyHeight = $('#header .main-header').outerHeight();
//         $('#header').css('padding-top', stickyHeight);
//       } else {
//         stickyDiv.removeClass('sticky');
//         var stickyHeight = $('#header .main-header').outerHeight();
//         $('#header').css('padding-top', 0);
//       }
//     });
//   }
// }


// function checkoutStatus() {
// 	 	var i = 0;
//   	var eachDone = true;
//     $('.gui-progressbar').find('ul li').each(function(){
//       i++;
//       var curClass = $(this).attr('class');
//       var curClassFirst = curClass.split(' ');
//       if (curClass.indexOf('gui-active') >= 0) {
//         $('.status-bar .'+curClassFirst[0]).addClass('active');
//         $('.status-bar .bar .active-bar').addClass('done-'+i);
//       } else {
//       	$('.status-bar .'+curClassFirst[0]).removeClass('active');
//         $('.status-bar .bar .active-bar').removeClass('done-'+i);
//       }
//       if (curClass.indexOf('gui-done') >= 0) {
//         $('.status-bar .'+curClassFirst[0]).addClass('done');
//       } else {
//       	$('.status-bar .'+curClassFirst[0]).removeClass('done');
//       }
//       if (curClass.indexOf('gui-done') >= 0 && i == 4) {
//       	$('.status-bar .bar .active-bar').addClass('done-all');
//       } else {
//       	$('.status-bar .bar .active-bar').removeClass('done-all');
//       }
//     });
// }

// function updatePayments() {
// 	$('.gui-payment-methods .gui-payment-method img').each(function(){
//     var cur  = $(this);
//     if (!cur.hasClass('updated')){
//       cur.addClass('updated');
//       if (cur.closest('label').find('input').attr('value')) {
//    			var method = cur.closest('label').find('input').attr('value').split('|')[1];
//         var pattern = "_",
//         re = new RegExp(pattern, "g");
//         var cMethod = method.replace(re, '-').replace('payment-', '').replace('icon-', '');

//         var provider = cur.closest('label').find('input').attr('value').split('|')[0];
//         var url = createUrlAssets((cMethod+'.png'));
//         if (provider != 'paynl' && provider != 'billink' && provider != 'cardgate' && provider != 'global-payments') {
//           cur.attr('src', url);
//         }
//     		}
//       }
    
//   });
// }

// function createMessage(data) {
//   var messages = $(data).find('div[class*="messages"] ul');
//   var message = messages.first('li').text();
//   var messageType = false;
//   var icon = '';

//   if (!message) {
//     message = false;
//   }

//   if( messages.hasClass('error') || messages.hasClass('gui-error') )
//   {
//     messageType = 'error';
//     icon = 'fa-times';
//   }
//   else if( messages.hasClass('success') || messages.hasClass('gui-success') )
//   {
//     messageType = 'success';
//     icon = 'fa-check';
//   } else if( messages.hasClass('info') || messages.hasClass('gui-info') ) {
//     messageType = 'info';
//     icon = 'fa-info';
//   }

//   if (message) {
//     $('.live-message .message .icon i').removeClass('fa-info fa-check fa-times');
//     $('.live-message').addClass('active');
//     $('.live-message .message .text ul li').text(message);
//     $('.live-message .message .icon i').addClass(icon);

//     setTimeout(function(){
//       $('.live-message').removeClass('active');
//     }, 4000);
//   }
// }

// function updateCart(btn, btnText, type, message, messageType, icon) {
//   if (btn) {
// 		btn.html(btnText);
// 	}
  
//   location.reload();
  
// //   $.get((basicUrl+'cart?format=json'), function(data){
// //       var cartQ = 0;
// //     	var cart = data.cart;
// //     	var shop = data.shop;	
    
// //       if (cart) {
// //         $('.cart-wrap .table table').empty().removeClass('hidden');
// //         $('.cart-wrap .empty-cart').addClass('hidden');
// //         $('.cart-wrap .shipping-discount').removeClass('hidden');
// //         if (data.textpage.content) {
// //         	$('.cart-wrap .cart-content').html(data.textpage.content);
// //         }
// //         $.each(cart.products, function(index, product){
// //         	cartQ = cartQ + parseInt(product.quantity);
// //           var html = '';
          
// //           html += '<tr>';
// //           html += '<td>';
// //             html += '<div class="image-wrap"><img src="'+ createImage(product.image, '200x200x2') +'"></div>';
// //           html += '</td>';
// //           html += '<td class="info-td">';
// //             html += '<div class="info">';
// //             	if (product.brand) {
// //               	html += '<div class="brand">'+ product.brand.title +'</div>';
// //               }
// //               html += '<a class="title" href="'+createUrl(product.url)+'">'
// //           		if (!product.bundled) {
// //           			html += product.title;
// //               } else {
// //               	html += (product.title.split('+')[0].trim());
// //               }
// //           		html += '</a>';
// //          		 	if (product.bundled) {
// //                 html += '<div class="bundled">';
// //                   html += '<ul>';
// //                 		$.each(product.bundled, function(index, product){
// //                     html += '<li>';
// //                       html += '<span class="plus"><i class="fa fa-plus"></i></span>';
// //                       html += '<span class="image"><img src="'+createImage(product.image, '75x75x2')+'"></span>';
// //                       html += '<a class="title" href="'+createUrl(product.url)+'">'+product.quantity+'x '+product.title+'</a>';
// //                     html += '</li>';
// //                     });
// //                   html += '</ul>';
// //                 html += '</div>';
// //               }
// //           		html += '<div class="extra-info">';
// //                   html += '<ul>';
// //                     if (product.variant) {
// //                       html += '<li class="variant">'+product.variant+'</li>';
// //                     }
// //                     if (product.custom) {
// //                     $.each(product.custom, function(index, custom){
// //                     	html += '<li><strong>'+custom.title+'</strong>';
// //                       	var valIndex = 0;
// //                         $.each(custom.values , function(index, value){
// //                           valIndex++;
// //                           html += ' '+htmlEntities(value.value);
// //                           //html += ' '+value.value;
// //                           if (value.price) {
// //                             html += ' (+'+money(value.price)+')';
// //                             if (valIndex != Object.keys(custom.values).length) {
// //                               html += ', ';
// //                             }
// //                           }    
// //                        });
// //                        html += '</li>';
// //                     });
// //                     }
          					
// //           					if (product.additional_cost.price_incl > 0) {
// //                     	html += '<li><strong>'+ajaxTranslations['Additional costs']+'&nbsp;</strong>';
// //                      if (shop.b2b) {
// //                     	html += money(product.additional_cost.price_excl);
// //                      } else {
// //                     	html += money(product.additional_cost.price_incl);
// //                      }
// //                     html += '</li>';
// //                     }
          
// //                   html += '</ul>';
// //               html += '</div>';
// //               html += '<div class="price visible-xs">';
// //               if (data.shop.b2b) {
// //               	html += money(product.price.price_excl);
// //               } else {
// //               	html += money(product.price.price_incl);
// //               }
// //               html += '</div>';
// //               if (mobileDevice) {
// //                 html += '<div class="input-wrap">';
// //                   html += '<div class="change">';
// //                     html += '<a href="javascript:;" data-way="down" class="down"><i class="fa fa-minus"></i></a>';
// //                     html += '<input type="text" name="'+ product.qid +'" value="'+ product.quantity +'" class="standard-input" />';
// //                     html += '<a href="javascript:;" data-way="up" class="up"><i class="fa fa-plus"></i></a>';
// //                   html += '</div>';
// //                 html += '</div>  ';
// //               }
// //             html += '</div>';
// //           html += '</td>';
// //           if (!mobileDevice) {
// //           html += '<td>';
// //           	html += '<div class="input-wrap">';
// //               html += '<div class="change">';
// //                 html += '<a href="javascript:;" data-way="down" class="down"><i class="fa fa-minus"></i></a>';
// //                 html += '<input type="text" name="'+ product.qid +'" value="'+ product.quantity +'" class="standard-input" />';
// //                 html += '<a href="javascript:;" data-way="up" class="up"><i class="fa fa-plus"></i></a>';
// //               html += '</div>';
// //             html += '</div>  ';
// //           html += '</td>';
// //           }
// //           html += '<td class="hidden-xs price-td">';
// //           	if (data.shop.b2b) {
// //             	html += '<div class="price">'+money(product.price.price_excl)+'</div>';
// //         		} else {
// //             	html += '<div class="price">'+money(product.price.price_incl)+'</div>';
// //             }
// //           html += '</td>';
// //           html += '<td>';
// //             	html += '<a href="javascript:;" data-url="'+createUrl(('cart/delete/'+product.qid))+'" class="cart-delete"><i class="sm sm-remove"></i></a>';
// //             html += '</td>';
// //         html += '</tr>';
          
// //          $('.cart-wrap .table table').append(html);
               
// //         });
        
        
// //       	$('[data-cart-items]').html(cartQ);
// //         // $('[data-cart-total-excl]').html(money(data.page.cart.total.price_excl));
// //         // $('[data-cart-total-vat]').html(money((data.page.cart.total.price_incl - data.page.cart.total.price_excl)));
// //         // $('[data-cart-total-incl]').html(money(data.page.cart.total.price_incl));
        
// //       } else { // if no products in cart
// //         $('.cart-wrap .table table').empty().addClass('hidden');
// //         $('.cart-wrap .empty-cart').removeClass('hidden');
// //         $('.cart-wrap .shipping-discount').addClass('hidden');
// //       	$('[data-cart-items]').html('0');
// //         if (type == 'delete') {
// //         	parent.$.fancybox.close();
// //       	}
// //         // $('[data-cart-total-excl]').html(money('0'));
// //         // $('[data-cart-total-vat]').html(money('0'));
// //         // $('[data-cart-total-incl]').html(money('0'));
// //       }
  
// //     var html = '';
// //     $('.cart-wrap .totals table').empty();
// //     if (cart.discount) {
// //         html += '<tr>';
// //            html += '<td>'+ajaxTranslations['Discount']+' '+(cart.discount.code ? '('+cart.discount.code+')' : '') +'<a href="'+createUrl('cart/unsetDiscount')+'" title="'+ajaxTranslations['Delete']+'" class="delete-discount">'+ajaxTranslations['Delete']+'</a></td>';
// //            html += '<td>-'+money(cart.discount.price.price_incl)+'</td>';
// //          html += '</tr>';
// //       }
// //       html += '<tr>';
// //         html += '<td>'+ajaxTranslations['Total excl. VAT']+'</td>';
// //     		if (cart) {
// //         	html += '<td>'+money(cart.totals.sub_total)+'</td>';
// //   			} else {
// //         	html += '<td>'+money(0)+'</td>';
// //         }
// //       html += '</tr>';
// //     	if (cart) {
// //       $.each(cart.totals.taxes, function(index, tax){
// //         html += '<tr>';
// //           html += '<td>'+tax.name.toUpperCase()+' ('+tax.percentage * 100+'%)</td>';
// //           html += '<td>'+money(tax.amount)+'</td>';
// //         html += '</tr>';
// //       });       
// //   		}
// //      if (cart.shipment) {
// //         html += '<tr>';
// //           html += '<td>'+ajaxTranslations['Shipping costs']+' <small>('+cart.shipment.title+')</small> <a href="'+createUrl('cart/unsetShipmentMethod')+'" class="delete-discount">'+ajaxTranslations['Delete']+'</a></td>';
// //           html += '<td>'+money(cart.shipment.price.price_incl)+'</td>';
// //         html += '</tr>';
// //       }
// //       html += '<tr>';
// //         html += '<td>'+ajaxTranslations['Total incl. VAT']+'</td>';
// //     		if (cart) {
// //         	html += '<td>'+money(cart.totals.grand_total)+'</td>';
// //         } else {
// //         	html += '<td>'+money(0)+'</td>';
// //         }
// //       html += '</tr>';

// //     $('.cart-wrap .totals table').html(html);
    
    
// //   }).done(function(){
// //   	$('.cart-popup').addClass('loaded');
// //     location.reload();
// //   });
  
// }

// function htmlEntities(str) {
//     return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
// }

// // UPDATE WISHLIST
//   function refreshWishlist () {
//   if (loggedIn) {
//     $.get(wishlistUrl, function(data){
//       var wishlist = data.wishlist;
//       var items = 0;
//       var wishlistIds = [];
      
//       $.each(wishlist, function(index, item){
//         items++;
//         var product = item.item;
//         wishlistIds.push(product.id);
//       });
      
//       var wishlistBtn = $('.add-to-wishlist'); 
//       $.each(wishlistBtn, function(){
//         var curId = $(this).data('id');
//         var cur = $(this);
        
//         if($.inArray(curId, wishlistIds) > -1){
//           cur.addClass('in-wishlist');
//         } else {
//           cur.removeClass('in-wishlist');
//         }    
//       });
      
//       if (items > 0) {
//       	$('[data-wishlist-items]').html(items);
//       } else {
//       	$('[data-wishlist-items]').html('');
//       }
      
//        if (items < 1 && $('#account-dashboard').length > 0) {
//      		 $('.wishlist-products').empty();
//           $('.wishlist-products').append('<div class="recent-product">'+ajaxTranslations['No products found']+'...</div>');
//        	}
      
//       if (items > 0 && $('#account-dashboard').length > 0) {
//           $.each(wishlist, function(index, product){
//             var item = product;
//             var product = product.item;
//           	var html = '';
//                 html += '<div class="recent-product '+theme.products_border+' '+ (theme.products_gray_image ? 'img-gray' : '') +' col-md-6 col-xs-12">';
//                 html += '<div class="flex inner">';
//                   html += '<div class="image-wrap">';
//                     html += '<a href="'+createUrl(product.url)+'">';
//                       html += '<img src="'+createImage(product.image, '200x200x2')+'" alt="'+product.title+'">';
//                     html += '</a>';
//                   html += '</div>';
//                   html += '<div class="info">';
//                     html += '<a class="title title-font" href="'+createUrl(product.url)+'">'+product.title+'</a>';
//                     html += '<div class="price">';      
//                       if (product.price.price_old) {
//                         html += '<span class="old-price">'+money(product.price.price_old)+'</span>';
//                       }
//                       html += '<span class="new-price">'+money(product.price.price)+'</span>';
//                     html += '</div>';
//                     html += '<div class="link"><a href="'+createUrl(product.url)+'">'+ ajaxTranslations['View product'] +'</a> - <a href="'+createUrl(('account/wishlistDelete/' + item.wid))+'">'+ ajaxTranslations['Delete'] +'</a></div>';
//                   html += '</div>';
//                 html += '</div>';
//               html += '</div>';
//             	$('.wishlist-products').append(html);
//           });
//       }
      
//     });
//   }
//   }
// // END UPDATE WISHLIST //

function updateQuantity(way, cur){
  	var quantity = parseInt(cur.closest('.input-wrap').find('input').val());
  
    if (way == 'up'){
      quantity++;
    } else {
      if (quantity > 1){
          quantity--;
      }
    }
    cur.closest('.input-wrap').find('input').val(quantity);
    if (cur.closest('.input-wrap').hasClass('cart-quantity')) {
      cur.closest('form').submit();
    }
}

// function createUrl(url) {
// 	url = basicUrl+url;
//   return url;
// }
// function createUrlAssets(url) {
// 	url = assetsUrl+url;
//   return url;
// }

// function createImage(id, format) {
// 	var imageUrl = '//static.webshopapp.com/shops/'+pad(shopId, 6)+'/files/'+pad(id, 9)+'/'+format+'/image.jpg';
//   return imageUrl;
// }

// function money(nStr) {
//   nStr = parseFloat(nStr).toFixed(2);
//   nStr += '';
//   var x = nStr.split('.');
//   var x1 = x[0];
//   var x2 = x.length > 1 ? '.' + x[1] : '';
//   var rgx = /(\d+)(\d{3})/;
//   while (rgx.test(x1)) {
//       x1 = x1.replace(rgx, '$1' + ',' + '$2');
//   }
//   var x3 =  (x1 + x2).split('.');
//   var x4 = x3[0].replace(',', '.') + ',' + x3[1]; 
//   if (nStr == 0) {
//   return '';
//   } else {
//   	return '€'+x4;
//   }
// }
// // function money (price) {
// //   price = parseFloat(price);
// //   if (price) {
// //     if ((priceStatus == 'login' && !loggedIn) || !priceStatus) {
// //       var priceMoney = shopCurrency+'--,--';
// //     } else {
// //   		var priceMoney = shopCurrency+''+ price.toFixed(2).replace('.', ',');
// //   	}
// //     if (shopCurrency == '$') {
// //       priceMoney = priceMoney.replace(',', '.');
// //     }
// //   } else {
// //   	var priceMoney = '';
// //   }
// //   return priceMoney;
// // }

// function money (price, currency = true) {
//   //price = parseFloat(price);
//   price = parseFloat(price) * wisselkoers;
//   price = price.toFixed(2);
//   price += '';
//   var x = price.split('.');
//   var x1 = x[0];
//   var x2 = x.length > 1 ? '.' + x[1] : '';
//   var rgx = /(\d+)(\d{3})/;
//   while (rgx.test(x1)) {
//       x1 = x1.replace(rgx, '$1' + ',' + '$2');
//   }
//   var x3 =  (x1 + x2).split('.');
//   var x4 = x3[0].replace(',', '.') + ',' + x3[1]; 
//   if (price) {
//     if ((priceStatus == 'login' && !loggedIn) || !priceStatus) {
//       var priceMoney = shopCurrency+'--,--';
//     } else {
//   		var priceMoney = shopCurrency+''+ x4;
//   	}
//     if (shopCurrency == '$') {
//       priceMoney = priceMoney.replace(',', '.');
//     }
//   } else {
//   	var priceMoney = '';
//   }
//   return priceMoney;
// }
    
// function pad (str, max) {
//   str = str.toString();
//   return str.length < max ? pad("0" + str, max) : str;
// }

// function urlencode(str){
//   return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').
//     replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
// }

// function liveSearch(cur){
//   var form = cur.closest('form');
//   var type = form.data('search-type');
//   var autocomplete = $('.search-autocomplete[data-search-type="'+type+'"]');
//   var input = $('[data-input='+type+']');
//   // console.log(type);
//   if ($(window).width() > 767) {
//   	var productLimit = 4;
//   } else {
//   	var productLimit = 4;
//   }
//   var query = input.val();
//   $('[data-search-query]').text(query);
//   query = urlencode(query.replace('/', '-slash-'));
  
//   //var form = $('.search-autocomplete form');
//   var selectedFilters = form.serialize();  
  
//   if(query.length > 2){
    
//     form.find('.icon-search').addClass('hidden');
//     form.find('.icon-hide-search').removeClass('hidden');
    
//     var foundCategories = {};
//     /*
//     $.each(shopCategories, function(index, category){
//       if ((category.title.toLowerCase()).indexOf(query.toLowerCase()) >= 0) {
//           foundCategories[category.id] = {'title': category.title, 'url': category.url};
//       }
//       if (category.subs) {
//         $.each(category.subs, function(index, category){
//           if ((category.title.toLowerCase()).indexOf(query.toLowerCase()) >= 0) {
//               foundCategories[category.id] = {'title': category.title, 'url': category.url};
//           }

//           if (category.subs) {
//             $.each(category.subs, function(index, category){
//               if ((category.title.toLowerCase()).indexOf(query.toLowerCase()) >= 0) {
//                 foundCategories[category.id] = {'title': category.title, 'url': category.url};
//               }
//             });
//           }

//         });
//       }
//   	});*/
    
//     $.each(shopCategories, function(index, category){
//       var searchCat = query.toLowerCase().replace(' ', '').replace('+', '');
//       var findCat = category.title.toLowerCase().replace(' ', '');
//       searchCat = searchCat.replace(new RegExp("\\+","g"), '');
//       findCat = findCat.replace(/ /g, '');
      
//       if ((findCat).indexOf(searchCat) >= 0) {
//           foundCategories[category.id] = {'title': category.title, 'url': category.url};
//       }
//       if (category.subs) {
//         var cat_up = shopCategories[category.id];
//         $.each(category.subs, function(index, category){
//           var findCat = category.title.toLowerCase().replace(' ', '');
//           findCat = findCat.replace(/ /g, '');
          
//           if ((findCat).indexOf(searchCat) >= 0) {
//             foundCategories[category.id] = {'title': category.title, 'url': category.url, 'path': cat_up['title']};
//           }

//           if (category.subs) {
//             var newCatUp = cat_up['title'] + ' / ' + category.title;
//             $.each(category.subs, function(index, category){
//               var findCat = category.title.toLowerCase().replace(' ', '');
//               findCat = findCat.replace(/ /g, '');
//               if ((findCat).indexOf(searchCat) >= 0) {
//                 foundCategories[category.id] = {'title': category.title, 'url': category.url, 'path': newCatUp};
//               }
//             });
//           }

//         });
//       }
//   	});
    
//     autocomplete.find('.feat-categories .cats ul').empty();
//     var loopIndex = 0;
//     $.each(foundCategories, function(index, category){
//       loopIndex++;
//       if (loopIndex <= 12) {
//         $('.search-autocomplete .feat-categories .cats ul').append('<li><a href="'+createUrl(category.url)+'">'+category.title+'</a></li>');
//       }
//     });
//     if (loopIndex == 0){
//     	autocomplete.find('.feat-categories').addClass('hidden');
//     } else {
//     	autocomplete.find('.feat-categories').removeClass('hidden');
//     }
    
//     var jsonUrl = searchUrl + query + '?limit='+productLimit+'&'+selectedFilters+'&format=json';
//     var ajaxUrl = searchUrl + query + '/page1.ajax?limit='+productLimit+'&'+selectedFilters;
    
//     $.get(ajaxUrl, function(json){
//         var productsHtml = [];
//         $.each(json.products, function(index, product){  
//           var productHtml = '';

//           productHtml += '<div class="product col-md-6">';
//           productHtml += '<div class="product-inner">';
//           productHtml += '<div class="image-wrap">';
//           productHtml += '<a href="'+product.url+'">';
//           productHtml += '<img src="'+product.image.replace('50x50x2', '100x100x2') +'" alt="MVTM Gunmetal Sandstone">';
//           productHtml += '</a>';
//           productHtml += '</div>';
//           productHtml += '<div class="info">';
//             if (product.brand) {
//               productHtml += '<div class="brand">'+product.brand.title+'</div>';
//             }
//           productHtml += '<a class="title" href="'+product.url+'">'+ product.title +'</a>';
//           productHtml += '<div class="price">'+ product.price.price_money +'</div>';
//           productHtml += '</div>';
//           productHtml += '</div>';
//           productHtml += '</div>';
					
//           productsHtml.push(productHtml);
//         });

//       productsHtml = productsHtml.join('');
      
//       autocomplete.find('.search-products').empty();
//       autocomplete.find('.search-products').html(productsHtml);
      
//       });
    
//     $.getJSON(jsonUrl, function(json){
// 			var collection = json.collection;
      
//       autocomplete.find('.custom-filters').empty();
//       if (collection.brands) {
//       	var html = '';
//         html+= '<div class="filter-wrap">';
//         html+= '<div class="filter-title title-font">'+ajaxTranslations['Brands']+'</div>';
//         html+= '<div class="filter-items">';
//           $.each(collection.brands, function(index, value){
//             if (value.id == collection.brand2.id) {
//             	var valueActive = 'checked="checked"';
//             } else {
//             	var valueActive = '';
//             }
//           html+= '<div class="ui checkbox filter-item">';
//             html+= '<input id="filter_'+value.id+'" type="radio" name="brand" value="'+value.id+'" '+valueActive+' />';
//             html+= '<label for="filter_'+value.id+'">'+value.title+'';
//             if (!value.active && value.has_count) {
//               html+= '<span>('+value.count+')</span>';
//             }
//             html+= '</label>';
//           html+= '</div>';
//           });
//         html+= '</div>';
//       html+= '</div>';
//       autocomplete.find('.custom-filters').append(html);
//     	}
//       if (collection.filters.custom) {
//       	$.each(collection.filters.custom, function(index, filter){
//       	var html = '';
        
//         html+= '<div class="filter-wrap">';
//         html+= '<div class="filter-title title-font">'+filter.title+'</div>';
//         html+= '<div class="filter-items">';
//           $.each(filter.values, function(index, value){
//             if (value.active) {
//             	var valueActive = 'checked="checked"';
//             } else {
//             	var valueActive = '';
//             }
//           html+= '<div class="ui checkbox filter-item">';
//             html+= '<input id="filter_'+value.id+'" type="checkbox" name="filter[]" value="'+value.id+'" '+valueActive+' />';
//             html+= '<label for="filter_'+value.id+'">'+value.title+'';
//             if (!value.active && value.has_count) {
//               html+= '<span>('+value.count+')</span>';
//             }
//             html+= '</label>';
//           html+= '</div>';
//           });
//         html+= '</div>';
//       html+= '</div>';
        
//         autocomplete.find('.custom-filters').append(html);
     
//     	});
//        }
//       autocomplete.find('.side .sort select').empty();
//       if (collection.sorts) {
//       	$.each(collection.sorts, function(index, sort){
//           var html = '';
//           if (collection.filters.sort == sort.id) {
//             $('.search-autocomplete .side .sort .dropdown .text').html(sort.title);
//             var selected = ' selected="selected"';
//           } else {
//           	var selected = '';
//           }
//         	html += '<option value="'+sort.id+'" '+selected+'>'+sort.title+'</option>';
//           $('.search-autocomplete .side .sort select').append(html);
//         });
//       }
      
//       if(collection.count > 0){
//         autocomplete.find('.more a').attr('href', createUrl(collection.internal.url + '?' + selectedFilters));
//         autocomplete.find('.more span').html('(' + collection.count + ')');
//         autocomplete.removeClass('noresults');
//       } else {
//         $('.search-autocomplete').addClass('noresults');
//       }
//       autocomplete.css('display', 'block');
//       $('.search-overlay').addClass('active');
//       $('.search-bar .search-wrap').css('z-index', '9999');
//     });
//   } else {
//     form.find('.icon-search').removeClass('hidden');
//     form.find('.icon-hide-search').addClass('hidden');
//     autocomplete.css('display', 'none');
//     $('.search-overlay').removeClass('active');
//     $('.search-bar .search-wrap').css('z-index', '0');
//   }
// }

//   // QUICK VIEW LIVE STOCK AND PRICE CHANGE //
//   function getActiveQuickviewVar(cur) {
//       var url = cur.find('option:selected').attr('data-url');
//       var stockLevel = parseInt(cur.find('option:selected').attr('data-stock-level'));
//       var available = cur.find('option:selected').attr('data-available');
//       var priceNew = cur.find('option:selected').attr('data-price');
//       var priceOld = cur.find('option:selected').attr('data-price-old');
//       var stockDiv = cur.closest('.product-info').find('.stock');
//    		var priceDivNew = cur.closest('.product-info').find('.price .new-price');
//     	var priceDivOld = cur.closest('.product-info').find('.price .old-price');
//     	var stockTrack = cur.find('option:selected').attr('data-stock-track');
//       if ((available == 'true' && stockLevel != 0) || stockTrack == 'false') {
//         if (showStockLevel && stockTrack == 'true') {
//           stockDiv.html('<div class="green success-color"><i class="fa fa-check"></i>'+stockLevel+' '+inStock_t_lower+'</div>');
//         } else {
//           stockDiv.html('<div class="green success-color"><i class="fa fa-check"></i>'+inStock_t_lower+'</div>');
//         }
//       } else if (available == 'true' && stockLevel == 0) {
//         stockDiv.html('<div class="orange warning-color">'+outOfStock_t_lower+'</div>');
//       } else {
//         stockDiv.html('<div class="red error-color"><i class="fa fa-times"></i>'+outOfStock_t_lower+'</div>');
//       }
//     	if (stockLevel < 1 && hide_countdown_no_stock) {
//         cur.closest('.product-info').find('.order-countdown').addClass('hidden');
//       } else {
//       	cur.closest('.product-info').find('.order-countdown').removeClass('hidden');
//       }
//       //priceDiv.html('<span class="old-price"><span class="price-wrap">'+priceOld+'</span></span><span class="new-price">'+priceNew+'</span>');
//     	priceDivNew.html('<span class="new-price">'+priceNew+'</span>');
//     	priceDivOld.html('<span class="old-price"><span class="price-wrap">'+priceOld+'</span></span>');
//       cur.closest('form').attr('action', url);
//   }

// function showCollectionLoad(){
//   $('.products .products-loader, .products .products-loader').addClass('visible');
// }

// var infiniteCollectionPageAvailable = false;
// var infiniteCollectionPageManual = false;
// var infiniteCollectionPage = 1;
// var infiniteCollectionBusy = false;
// var infiniteCollectionRemaining = 0;
// function infiniteCollectionInit(url, page, mode){
//   infiniteCollectionPageAvailable = true;

//   $('.blog-spinner-more').click(function(){
//     infiniteCollectionLoad(url, mode);
//     return false;
//   });
//   $('.collection-spinner.manual .collection-spinner-more').live('click', function(){
//   	infiniteCollectionLoad(url, mode);
//     return false;
//   });

//   $(document).scroll(function(){
//     if(infiniteCollectionPageAvailable && !infiniteCollectionPageManual){
      
//       if(page == 'blog'){
//         var offsetFromScreen = ($(window).height() + $(window).scrollTop()) - $('.blog-spinner').offset().top;
  
//         if(offsetFromScreen > 0){
//           infiniteBlogLoad(url, mode);
//         }
//       } else {

//         if($('.collection-spinner').length > 0){
//           var offsetFromScreen = ($(window).height() + $(window).scrollTop()) - $('.collection-spinner').offset().top;
    
//           if(offsetFromScreen > 0){
//             infiniteCollectionLoad(url, mode);
//           }
//         }
//       }
      
//     }
//   });
//   //$(document).scroll();
// }

// function getAjaxTranslation(key){
//   if(translation = eval('ajaxTranslations["' + key + '"]')){
//     return translation;
//   }
//   return key;
// }

// function showCollectionLoad(){
//   $('.products .products-loader, .products .products-loader').addClass('visible');
// }

// function infiniteBlogLoad(url, mode){
  
//   if(!infiniteCollectionBusy){
//     infiniteCollectionBusy = true;
//     $('.blog-spinner').addClass('busy');
//     infiniteCollectionPage++;
//     url = url.replace('page1.ajax', 'page' + infiniteCollectionPage + '.html?format=json');
//     $.getJSON(url, function(json){
//       if(json.blog.articles){
        
//         infiniteCollectionRemaining = 5 - (json.blog.pagination.page * 5);

//         if(infiniteCollectionRemaining < 5){
//           $('.blog-spinner-more span').text(infiniteCollectionRemaining);
//         }

//         if(json.blog.pagination.pages <= infiniteCollectionPage){
//           infiniteCollectionPageAvailable = false;
//           $('.blog-spinner').remove();
//         }

//         if(infiniteCollectionPage > 100){
//           infiniteCollectionPageManual = true;
//           $('.blog-spinner').addClass('manual');
//         }

//         var counter = 1;
        
//         var sortArticles = {};
//         var count = 1;
    
//         $.each(json.blog.articles, function(index, article){
//           var thisDate = article.date.replace(' ', '-').replace(':', '-') + count++;
//           sortArticles[thisDate] = article;
//         });
        
//         var articles = {};
//         var number = 5;
        
//         $.each(sortArticles, function(index, article){
//           articles[number--] = article;
//         });
        
//         $.each(articles, function(index, article){
                     
//             var container = $('.blog-articles.inf-articles');
//           	var blogCol = container.data('blogcol');
//   					var html = '';
          	
          
//           	html += '<div class="blog-article '+blogCol+'">';
//               html += '<div class="flex">';
//                 html += '<div class="date">'+moment(article.date).format('DD MMM Y')+'</div>';
//                 html += '<a href="'+ createUrl(article.url) +'" class="title title-font">'+article.title+'</a>';
//                 html += '<div class="summary">';

//                   html += '<span class="content hidden-xs">';
//           				html += article.summary;
//                   html += '</span>';
//                   html += '<a class="read-more" href="'+ createUrl(article.url) +'"> '+ajaxTranslations['Read more']+'</a>';
//                 html += '</div>';
//                 html += '<a class="image-wrap" href="'+ createUrl(article.url) +'">';
//                 html += '<div class="image" style="background: url('+createImage(article.image)+') #f7f7f7 no-repeat center center; -webkit-background-size: cover; -moz-background-size: cover; -o-background-size: cover; background-size: cover;"></div>';
//                 html += '</a>';
//               html += '</div>';
//             html += '</div>';
          	
//           	//container.append(html);
//           	var $html = $(html);
//           	container.append($html).masonry( 'appended', $html );

//           counter++;       
//         });
//       }
         
//       infiniteCollectionBusy = false;
//       $('.collection-spinner').removeClass('busy');
//       $(document).scroll();
      
//     });
//   }
// }

// function infiniteCollectionLoad(url, mode){
//   if(!infiniteCollectionBusy){
//     infiniteCollectionBusy = true;
//     $('.collection-spinner').addClass('busy');
//     infiniteCollectionPage++;
//     url = url.replace('page1.ajax', 'page' + infiniteCollectionPage + '.ajax');
//     $.getJSON(url, function(json){
//       if(json.products){
        
//         infiniteCollectionRemaining = json.count - (json.page * json.limit);

//         if(infiniteCollectionRemaining < json.limit){
//           $('.collection-spinner-more span').text(infiniteCollectionRemaining);
//         }

//         if(json.pages <= infiniteCollectionPage){
//           infiniteCollectionPageAvailable = false;
//           $('.collection-spinner').remove();
//         }

//         if(infiniteCollectionPage > 100){
//           infiniteCollectionPageManual = true;
//           $('.collection-spinner').addClass('manual');
//         }

//         var counter = 1;
//         $.each(json.products, function(index, product){  
//           var infiniteUrl = product.url +'?format=json';
//           var wishlistUrl = basicUrl+'account/wishlistAdd/'+product.id+'/?variant_id='+product.vid;
//           var compareUrl = basicUrl+'compare/add/'+product.vid+'/';
//           var cartUrl = basicUrl+'cart/add/'+product.vid+'/';
//           var productType = $('.products').find('.product').first().data('product-type');
//           if (product.image) {
//           	var imageUrl = product.image.replace('50x50x2', (image_ratio+'x'+image_fit));
//         	} else {
//           	var imageUrl = 'http://via.placeholder.com/'+image_ratio+'/ffffff/000000?text='+imageNotFound_t+'';
//           }
//           var plainImage = product.image.replace('/50x50x2/', '/');
//           var labelText = '';
//           if (product.price.price_old) {
//             if (!showProductsPercentage) {
//             	var labelText = 'sale';
//             } else {
//             	var labelText = (((product.price.price - product.price.price_old)/product.price.price_old)*100).toFixed(0)+ '%';
//             }
//           }
          
//           var container = $('.products');
          
//           var quickviewWrap = $('<div>').append($('.products').find('.quickview-popup').first().clone()).html().replace('inf_id_here', product.id).replace('quickview-loaded', '');
//           var productWrap = $('<div>').append($('.products').find('.inf-product').first().clone()).html().replace('inf_id_here', product.id).replace('img-loaded', '').replace('has-more', '');
          
//           container.append(quickviewWrap);
//           container.append(productWrap);
//           var productObject = $('.products').find('.inf-product[data-inf-id="'+product.id+'"]');
//         	var quickviewObject = $('.products').find('.quickview-popup[data-inf-id="'+product.id+'"]');
          
//           productObject.find('.sec').remove();
//           quickviewObject.attr('id', product.id);
//           if (product.brand) {
//           	quickviewObject.find('[data-infinite-product-brand]').html(product.brand.title);
//           } else {
//           	quickviewObject.find('[data-infinite-product-brand]').empty();
//           }
//           quickviewObject.find('[data-infinite-product-title]').html(product.title);
//           if (product.code) {
//           	quickviewObject.find('[data-infinite-product-code]').html('<span class="title">'+articleCode_t+'</span> '+product.code);
//           } else {
//           	quickviewObject.find('[data-infinite-product-code]').empty();
//           }
//           quickviewObject.find('[data-infinite-product-price-new]').html(product.price.price_money);
//           quickviewObject.find('[data-infinite-product-price-old]').html(product.price.price_old_money);
//           quickviewObject.find('[data-infinite-product-price-incl]').html(product.price.price_incl_money);
//           if (product.description) {
//             quickviewObject.find('[data-infinite-product-description]').html(product.description);
//           } else {
//           	quickviewObject.find('[data-infinite-product-description]').empty();
//           }
//           if (product.available) {
//           	quickviewObject.find('[data-infinite-product-stock]').html('<div class="green"><i class="fa fa-check"></i>'+inStock_t_lower+'</div>');
//         	} else {
//             quickviewObject.find('[data-infinite-product-stock]').html('<div class="red"><i class="fa fa-times"></i>'+outOfStock_t_lower+'</div>');
//           }
//           quickviewObject.find('[data-infinite-product-form]').attr('action', cartUrl);
//           quickviewObject.find('a[data-infinite-wishlist-href]').attr('href', wishlistUrl);
//           quickviewObject.find('[data-infinite-product-yotpo]').attr('data-url', 'https://api.yotpo.com/products/'+yotpo_id+'/'+product.id+'/bottomline');
//           quickviewObject.find('[data-infinite-product-normal-stars]').empty();
          
          
//           productObject.attr({'data-id': product.id, 'data-url': product.url});
//           productObject.find('.product-labels').html('<div class="product-label sale">'+labelText+'</div>');
//           productObject.find('a[data-infinite-wishlist-jquery]').attr('data-url', wishlistUrl);
//           productObject.find('a[data-infinite-wishlist-href]').attr('href', wishlistUrl);
//           productObject.find('a[data-infinite-compare-href]').attr('href', compareUrl);
//           productObject.find('a[data-infinite-compare-add]').attr('data-add-url', createUrl(('compare/add/'+product.vid)));
//           productObject.find('a[data-infinite-compare-del]').attr('data-del-url', createUrl(('compare/delete/'+product.vid)));
//           productObject.find('a[data-infinite-quickview-button]').attr('data-product-url', product.url);
//           productObject.find('a[data-infinite-quickview-link]').attr('href', '#'+product.id);
//           productObject.find('a[data-infinite-product-url]').attr({'href': product.url, 'title': product.title});
//           productObject.find('[data-infinite-product-image]').attr({'src': imageUrl, 'title': product.title, 'alt': product.title});
//           if (product.brand) {
//           	productObject.find('[data-infinite-product-brand]').html(product.brand.title);
//         	} else {
//           	productObject.find('[data-infinite-product-brand]').empty();
//           }
//           productObject.find('[data-infinite-product-title]').attr({'href': product.url, 'title': product.title}).html(product.title);
//           productObject.find('[data-infinite-product-description]').html(product.description);
//           productObject.find('[data-infinite-product-price-new]').html(product.price.price_money);
//           productObject.find('[data-infinite-product-price-old]').html(product.price.price_old_money);
//           productObject.find('[data-infinite-product-price-incl]').html(product.price.price_incl_money);
//           productObject.find('[data-infinite-product-price-unit]').html(product.unit.price_money);
//           productObject.find('[data-infinite-product-unit]').html(product.unit.unit);
//           productObject.find('[data-infinite-product-wishlist-input]').attr('id', ('add_compare_'+productType+product.id)).attr('data-add-url', createUrl(('compare/add/'+product.vid+'/'))).attr('data-del-url', createUrl(('compare/delete/'+product.vid+'/'))).attr('data-id', product.id).removeAttr('checked');
//           productObject.find('[data-infinite-product-wishlist-label]').attr('for', ('add_compare_'+productType+product.id));
//           productObject.find('[data-infinite-product-yotpo]').attr('data-url', 'https://api.yotpo.com/products/'+yotpo_id+'/'+product.id+'/bottomline');
//           productObject.find('[data-infinite-product-normal-stars]').empty();
//           if (product.score) {
//             var productScore = product.score * 10;
//           } else {
//             var productScore = 0;
//           }
//           var roundHalf = (productScore / 2).toFixed(1);
//           var stars = roundHalf.split('.');
//           var fullStars = parseFloat(stars[0]);
//           var halfStars = 0;
//           if (stars[1] != 0) {
//             halfStars = 1;
//           } else {
//             halfStars = 0;
//           }
//           var emptyStars = (5 - (fullStars + halfStars));

//           if (fullStars) {
//             for (i = 0; i < fullStars; i++) {
//               productObject.find('[data-infinite-product-normal-stars]').append('<i class="fa fa-star yellow"></i>');
//               quickviewObject.find('[data-infinite-product-normal-stars]').append('<i class="fa fa-star yellow"></i>');
//             }
//           }
//           if (halfStars) {
//             for (i = 0; i < halfStars; i++) {
//               productObject.find('[data-infinite-product-normal-stars]').append('<i class="fa fa-star-half-o yellow"></i>');
//               quickviewObject.find('[data-infinite-product-normal-stars]').append('<i class="fa fa-star-half-o yellow"></i>');
//             }
//           }
//           if (emptyStars) {
//             for (i = 0; i < emptyStars; i++) {
//               productObject.find('[data-infinite-product-normal-stars]').append('<i class="fa fa-star-o yellow"></i>');
//               quickviewObject.find('[data-infinite-product-normal-stars]').append('<i class="fa fa-star-o yellow"></i>');
//             }
//           }
          
          
//           counter++;       
//         });
//       }
//       loadYotpoStars();
//       compare();
      
//       infiniteCollectionBusy = false;
//       $('.collection-spinner').removeClass('busy');
//       $(document).scroll();
//     });
//   }
// }

// function reload_js(src) {
//   $('script[src="' + src + '"]').remove();
//   $('<script>').attr('src', src).appendTo('head');
// }

// function loadYotpoStars(){
//   if ($('.yotpo-stars').length > 0) {
//   	$('.yotpo-stars .stars').each(function(){
//     var cur = $(this);
//   	var url = $(this).data('url');
//     cur.empty();
//     for (i = 0; i < 5; i++) {
//       cur.append('<i class="fa fa-star-o yellow"></i>');
//     }
		
//      $.get(url, function(data){
//       cur.empty();
//       if (data) {
        
//         if (data.response.bottomline.average_score) {
//           var productScore = data.response.bottomline.average_score * 2;
//         } else {
//         	var productScore = 0;
//         }
//         var roundHalf = (productScore / 2).toFixed(1);
//         var stars = roundHalf.split('.');
//         var fullStars = parseFloat(stars[0]);
//         var halfStars = 0;
//         if (stars[1] != 0) {
//         	halfStars = 1;
//         } else {
//         	halfStars = 0;
//         }
//         var emptyStars = (5 - (fullStars + halfStars));
        
//         if (fullStars) {
//           for (i = 0; i < fullStars; i++) {
// 						cur.append('<i class="fa fa-star yellow"></i>');
//           }
//         }
//         if (halfStars) {
//           for (i = 0; i < halfStars; i++) {
// 						cur.append('<i class="fa fa-star-half-o yellow"></i>');
//           }
//         }
//         if (emptyStars) {
//           for (i = 0; i < emptyStars; i++) {
// 						cur.append('<i class="fa fa-star-o yellow"></i>');
//           }
//         }
        
//       }
//     });

      
      
//   });
// 	}
//   if ($('.yotpo-reviews').length > 0) {
//     var url = $('.yotpo-reviews').data('url');
//     $.get(url, function(data){
//     	var reviews = data.response.reviews;
//       var reviewsLength = data.response.bottomline.total_review;
      
//       $('[data-yotpo-q]').html(reviewsLength);
//       $('[data-yotpo-score]').html(data.response.bottomline.average_score.toFixed(1).replace('.', ','));
      
//       if (reviewsLength == 0) {
//         $('.yotpo-reviews .custom-pager').addClass('hidden');
//         $('.yotpo-reviews .no-reviews').removeClass('hidden');
//       } else {
//         //$('.reviews-block .wrap').removeClass('hidden');
//       }
      
//       var chunks = [];
//       for (var i=0; i<reviewsLength;) {
//           chunks.push(reviews.slice(i, i+=5));
//       }
      
//       var loopIndex = 0;
//       var fiveStars = 0;
//       var fourStars = 0;
//       var threeStars = 0;
//       var twoStars = 0;
//       var oneStar = 0;
			
//       $.each(chunks, function(index, reviews){
//         loopIndex++;
//         if (loopIndex == 1) {
//           $('<li class="number active" data-index="'+loopIndex+'"><a href="javascript:;" data-index="'+loopIndex+'">'+loopIndex+'</a></li>').insertBefore('.yotpo-reviews .custom-pager ul li.next');
//         } else {
//           $('<li class="number" data-index="'+loopIndex+'"><a href="javascript:;" data-index="'+loopIndex+'">'+loopIndex+'</a></li>').insertBefore('.yotpo-reviews .custom-pager ul li.next');
//         }
//         var html = '';
//         html += '<div class="page" data-index="'+loopIndex+'">';
//         html += '<div class="reviews">';
        
//         $.each(reviews, function(index, review){
//           if (review.score == 5) {
//             fiveStars++;
//           } else if (review.score == 4) {
//             fourStars++;
//           } else if (review.score == 3) {
//             threeStars++;
//           } else if (review.score == 2) {
//             twoStars++;
//           } else if (review.score == 1) {
//             oneStar++;     
//           }
//           var publishDate = moment(review.date).format('D ');
//           publishDate += ajaxTranslations[moment(review.date).format('MMMM')];
//           publishDate += moment(review.date).format(' YYYY');

//           if (review.score) {
//             var productScore = review.score * 2;
//           } else {
//             var productScore = 0;
//           }
//           var roundHalf = (productScore / 2).toFixed(1);
//           var stars = roundHalf.split('.');
//           var fullStars = parseFloat(stars[0]);
//           var halfStars = 0;
//           if (stars[1] != 0) {
//             halfStars = 1;
//           } else {
//             halfStars = 0;
//           }
//           var emptyStars = (5 - (fullStars + halfStars));            
          
// 					var rhtml = '';
//           rhtml += '<div class="review">';
//             rhtml += '<div class="review-inner">';
//               rhtml += '<div class="date">'+publishDate+'</div>'; 
//               rhtml += '<div class="top">';
//                 rhtml += '<div class="title title-font">'+review.user.display_name+'</div>';
//                 rhtml += '<div class="stars-wrap">';
//                   rhtml += '<div class="stars">';
          					
//           					if (fullStars) {
//                       for (i = 0; i < fullStars; i++) {
//                         rhtml += '<i class="fa fa-star"></i>';
//                       }
//                     }
//                     if (halfStars) {
//                       for (i = 0; i < halfStars; i++) {
//                         rhtml += '<i class="fa fa-star-half-o"></i>';
//                       }
//                     }
//                     if (emptyStars) {
//                       for (i = 0; i < emptyStars; i++) {
//                         rhtml += '<i class="fa fa-star-o"></i>';
//                       }
//                     }
          					
//                   rhtml += '</div>';
//                 rhtml += '</div>';
//               rhtml += '</div>';
//               rhtml += '<div class="content">'+review.content+'</div>';
//             rhtml += '</div>';
//           rhtml += '</div>';
//           $('.mobile-reviews .reviews').append(rhtml);
// 					html += rhtml;
//         });

//         html += '</div>';
//         html += '</div>';
        
//         $('.yotpo-reviews .reviews-slider').append(html);
//       });
  
//       $('.product-reviews .summary .col[data-stars="5"] .bar .fill').css('width', (fiveStars/reviewsLength*100)+'%');
//       $('.product-reviews .summary .col[data-stars="4"] .bar .fill').css('width', (fourStars/reviewsLength*100)+'%');
//       $('.product-reviews .summary .col[data-stars="3"] .bar .fill').css('width', (threeStars/reviewsLength*100)+'%');
//       $('.product-reviews .summary .col[data-stars="2"] .bar .fill').css('width', (twoStars/reviewsLength*100)+'%');
//       $('.product-reviews .summary .col[data-stars="1"] .bar .fill').css('width', (oneStar/reviewsLength*100)+'%');
      
//     }).done(function(){
//     	$('.yotpo-reviews .reviews-slider').owlCarousel({
//         loop:false,
//         items:1,
//         smartSpeed: 0,
//         autoHeight:true,
//         mouseDrag:false,
//         touchDrag:false
//         //dots:true
//       }).on('changed.owl.carousel', function(){
//         setTimeout(function(){
//           var activePage = $('.reviews-slider .owl-item.active').find('.page').data('index');
//           $('.product-reviews .custom-pager .number.active').removeClass('active');
//           $('.product-reviews .custom-pager .number[data-index="'+activePage+'"]').addClass('active');
//         }, 50);
//       });
//     });
    
//   }
// }

// function compare() {
// 	$.get(compareUrl, function(data){
    
//     var products = data.page.compare;
//     var compareIds = [];
    
//     if (products) {
//     	products = products.reverse();
//   	}
		

//     $('.compare-products').empty();
    
//     if (products) {
//       $('.compare-pop').addClass('active');
//       $('[data-compare-items]').html(products.length);
//     } else {
//       $('.compare-pop').removeClass('active').removeClass('open');
//       $('.compare-overlay').removeClass('active');
//       $('[data-compare-items]').html(0);
//     }
    
//     if (products) {
//     $.each(products, function(index, product){
//     	var html = '';
//       compareIds.push(product.id);
      
//       if (product.score) {
//         var productScore = product.score * 10;
//       } else {
//         var productScore = 0;
//       }
//       var roundHalf = (productScore / 2).toFixed(1);
//       var stars = roundHalf.split('.');
//       var fullStars = parseFloat(stars[0]);
//       var halfStars = 0;
//       if (stars[1] != 0) {
//         halfStars = 1;
//       } else {
//         halfStars = 0;
//       }
//       var emptyStars = (5 - (fullStars + halfStars));
      
//         html += '<div class="compare-product">';
//         html += '<div class="inner">';
//         html += '<div class="image">';
//         html += '<img src="'+createImage(product.image, '300x300x2')+'">';
//         html += '</div>';
//         html += '<div class="info">';
//         html += '<div class="product-brand">'+product.brand.title+'</div>';
//         html += '<a href="'+createUrl(product.url)+'" title="'+product.fulltitle+'" class="title title-font">'+ product.title+'</a>';
        
//       	html += '<div class="stars-price">';  
//         if (theme.products_show_stars) { 
//         html += '<div class="product-stars'+(theme.yotpo_id ? ' yotpo-stars' : '')+'">';
          
//         if (theme.yotpo_id) {
//       	html += '<div class="yotpo-stars">';
//         html += '<div class="stars" data-url="https://api.yotpo.com/products/'+theme.yotpo_id+'/'+product.id+'/bottomline">'; 
//         // stars 1..5
//         html += '</div>';
//         html += '</div>';
//         } else { // theme.yotpo_id
//         html += '<div class="stars">';
          
//         if (fullStars) {
//         for (i = 0; i < fullStars; i++) {
//         html+='<i class="fa fa-star yellow"></i>';
//         }
//         }
//         if (halfStars) {
//         for (i = 0; i < halfStars; i++) {
//         html+='<i class="fa fa-star-half-o yellow"></i>';
//         }
//         }
//         if (emptyStars) {
//         for (i = 0; i < emptyStars; i++) {
//         html+='<i class="fa fa-star-o yellow"></i>';
//         }
//         }
          
//         html += '</div>';
//         } // theme.yotpo_id
//         html += '</div>';
//         } // end theme.products_show_stars
//         html += '<div class="price">';
//         html += '<div class="new-price">'+money(product.price.price)+'</div>';
//         html += '</div>';
//       	html += '</div>';
//       	html += '</div>';
//         html += '<div class="delete">';
//         html += '<a class="delete-compare" data-del-url="'+createUrl(('compare/delete/'+product.vid))+'" href="javascript:;"><i class="sm sm-remove"></i></a>';
//         html += '</div>';
//         html += '</div>';
//         html += '</div>';
      
//       $('.compare-products').prepend(html);
          
//     });
      
//   	}
    
//     loadYotpoStars();
    
//       $('.compare-check').each(function(){
//         var curId = $(this).attr('data-id');
//         curId = parseFloat(curId);
//         var cur = $(this);
        
//         if($.inArray(curId, compareIds) > -1){
//            cur.prop('checked', 'checked');
//         } else {
//           cur.removeAttr('checked');
//         }    
//       });
    
    
//   });
// }

// // email check//
// function isValidEmailAddress(emailAddress) {
//               var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
//               return pattern.test(emailAddress);
// };

function checkLoop(loopItems, maxItems){
  var setLoop = false;
  if(loopItems > maxItems){
    setLoop =  true;
  }
	return setLoop;  
}

function setLoop(loopItems, maxItems){
  if($.isNumeric(maxItems)){
  	return checkLoop(loopItems, maxItems);
  } else {
  	if (maxItems.indexOf('|') != -1) {
    	var splitItems = maxItems.split('|');
      
      if($(window).width() >= 1200){
      	return checkLoop(loopItems, splitItems[0]);
      } else if($(window).width() >= 992){
      	return checkLoop(loopItems, splitItems[1]);
    	} else if($(window).width() >= 768){
      	return checkLoop(loopItems, splitItems[2]);
      } else { 
      	return checkLoop(loopItems, splitItems[3]);
      }
  	}
  }
}

// function lightOrDark(color) {

//     // Variables for red, green, blue values
//     var r, g, b, hsp;
    
//     // Check the format of the color, HEX or RGB?
//     if (color.match(/^rgb/)) {

//         // If HEX --> store the red, green, blue values in separate variables
//         color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
        
//         r = color[1];
//         g = color[2];
//         b = color[3];
//     } 
//     else {
        
//         // If RGB --> Convert it to HEX: http://gist.github.com/983661
//         color = +("0x" + color.slice(1).replace( 
//         color.length < 5 && /./g, '$&$&'));

//         r = color >> 16;
//         g = color >> 8 & 255;
//         b = color & 255;
//     }
    
//     // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
//     hsp = Math.sqrt(
//     0.299 * (r * r) +
//     0.587 * (g * g) +
//     0.114 * (b * b)
//     );

//     // Using the HSP value, determine whether the color is light or dark
//     if (hsp>127.5) {

//         return 'light';
//     } 
//     else {

//         return 'dark';
//     }
// }

// var getUrlParameter = function getUrlParameter(sParam) {
//     var sPageURL = window.location.search.substring(1),
//         sURLVariables = sPageURL.split('&'),
//         sParameterName,
//         i;

//     for (i = 0; i < sURLVariables.length; i++) {
//         sParameterName = sURLVariables[i].split('=');

//         if (sParameterName[0] === sParam) {
//             return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
//         }
//     }
// };

// function removeParams(sParam)
// {
//             var url = window.location.href.split('?')[0]+'?';
//             var sPageURL = decodeURIComponent(window.location.search.substring(1)),
//                 sURLVariables = sPageURL.split('&'),
//                 sParameterName,
//                 i;
         
//             for (i = 0; i < sURLVariables.length; i++) {
//                 sParameterName = sURLVariables[i].split('=');
//                 if (sParameterName[0] != sParam) {
//                     url = url + sParameterName[0] + '=' + sParameterName[1] + '&'
//                 }
//             }
//             return url.substring(0,url.length-1);
// }

// function account_regions(country_id) {
	
//   var country_code = accountCountries[country_id]['code'];
//   var has_regions = accountCountries[country_id]['has_regions'];
//   console.log(has_regions);
//   var url = regionsUrl + '?country='+country_code;
//   if ($('#account-dashboard select[name="region_id"]').attr('data-current')) {
//     var current_regio = $('#account-dashboard select[name="region_id"]').attr('data-current');
//   }
  
//   if (has_regions) {
//   $.get(url, function(data){
//   	$('#account-dashboard select[name="region_id"]').empty();
//     $.each(data.regions, function(index, region){ 
//         if (current_regio == region.id) {
//           $('#account-dashboard select[name="region_id"]').append('<option value="'+region.id+'" selected="selected">'+region.name+'</option>');     
//         } else {
//       		$('#account-dashboard select[name="region_id"]').append('<option value="'+region.id+'">'+region.name+'</option>');     
//         }
//       });
//   }).done(function(){
//     var curSelected = $('#account-dashboard select[name="region_id"] option[selected="selected"]').text();
//     $('#account-dashboard select[name="region_id"] ~ .text').html(curSelected);
//     $('#account-dashboard select[name="region_id"]').closest('.custom-select').removeClass('hidden');
//     $('#account-dashboard [name="region"]').val(curSelected).addClass('hidden');
//   });
//   } else {
//     	$('#account-dashboard select[name="region_id"]').closest('.custom-select').addClass('hidden');
//       $('#account-dashboard [name="region"]').removeClass('hidden');
//   }
  
// }

// function refreshChats() {
  
//   if ($('.chat-box-inner').length > 0) {
//     var url = $('.chat-box-inner').data('url') + '?format=json';
//     var currentMessages = $('.chat-box-inner').attr('data-messages');
//     var newQ = 0;
    
//     $.get(url, function(data){
//     	var messages = data.ticket.messages;
//       messages = messages.reverse();
//       newQ = messages.length;
//       $('.chat-box-inner').empty();
     
//       $.each(messages, function(index, message){
//         var messageType = 0;
//       	if (message.name == data.page.account.fullname) {
//           var messageType = 'sent';
//         } else {
//           var messageType = 'received';
//         }
				
//         var html = '';
//         html += '<div class="chat-message '+messageType+'">';
//           html += '<div class="message">';
//         		if (data.ticket.messages[index - 1]) {
//             if (data.ticket.messages[index - 1]['name'] != message.name && messageType == 'received') {
//             	html += '<div class="name">'+message.name+'</div>';
//             }
//             }
//             html += '<div class="text">'+message.message+'</div></div>';
//         	if (data.ticket.messages[index + 1]) {
//            if (data.ticket.messages[index + 1]['name'] != message.name) {
//           		html += '<div class="date">'+message.date+'</div>';
//            }
//       		} else {
//           	html += '<div class="date">'+message.date+'</div>';
//           }
//         html += '</div>';
//         $('.chat-box-inner').prepend(html);
//       });
//     }).done(function(){
//       if (currentMessages != newQ) {
//         $('.chat-box-outer').scroll();
//         var height = $('.chat-box-outer').innerHeight();
//         $('.chat-box-outer').animate({
//           scrollTop: 50000
//         }, 0);
//     	}
//       $('.chat-box-inner').attr('data-messages', newQ);
//     });
    
//   }
  

// }

// function subsHeight() {
// 	var subsHeight = 0;
//   $('.mobile-menu .subs.active').each(function(){
//     var test = $(this).find('ul').outerHeight();
//     if (test > subsHeight) {
//       subsHeight = test;
//     }
//   });
//   if (subsHeight > 0) {
//     $('.mobile-menu .menu').css('height', subsHeight);
//   } else {
//     $('.mobile-menu .menu').css('height', 'auto');
//   }
// }

$(document).ready(function() {
  // Function to initialize the carousel
  window.initializeCarousel = function() {
    $('.product-carousel').each(function() {
      var carouselId = '#' + $(this).attr('id');
      if (!$(carouselId).hasClass('owl-loaded')) { // Check if the carousel is not already initialized
        $(carouselId).owlCarousel({
          items: 1,
          dots: true,
          lazyLoad: true,
        });
      }
    });
  }

  // Function to destroy the carousel
  function destroyCarousel() {
    $('.product-carousel').each(function() {
      var carouselId = '#' + $(this).attr('id');
      var owlCarouselData = $(carouselId).data('owl.carousel');
      if (owlCarouselData) {
        owlCarouselData.destroy();
      }
      $(carouselId).removeClass('owl-loaded');
    });
  }

  // Initial check
  if ($(window).width() <= 768) {
    initializeCarousel();
  }

  // Re-initialize carousel on resize
  $(window).on('resize', function() {
    var windowWidth = $(window).width();
    if (windowWidth <= 768) {
      initializeCarousel();
    } else {
      destroyCarousel();
    }
  });
});